export default {
  // Navigation
  'nav.trips': 'Trips',
  'nav.findTrips': 'Find Trips',
  'nav.chat': 'Chat',
  'nav.welcomeBack': 'Welcome back!',
  'nav.logout': 'Logout',
  'nav.settings': 'Settings',
  'nav.wallet': 'Wallet',
  'nav.profile': 'Profile',
  'nav.notifications': 'Notifications',
  'nav.noNotifications': 'No notifications',
  'nav.markAllRead': 'Mark all as read',
  
  // Flexy Courie
  'nav.flexyCourie': 'Flexy Courier',
  'nav.flexyRide': 'Flexy Ride',
  'nav.asSender': 'As Sender',
  'nav.asTraveler': 'As Traveler',
  'nav.driver': 'Driver',
  'nav.passenger': 'Passenger',
  'nav.mySeatListings': 'My Seat Listings',
  'nav.viewManageSeatListings': 'View and manage your seat listings',
  'nav.myRequests': 'My Requests',
  'nav.viewSeatRequests': 'View your seat requests',
  'nav.createSeatListing': 'Create Seat Listing',
  'nav.listNewSeat': 'List a new seat',
  'nav.myPassengerListings': 'My Passenger Listings',
  'nav.viewManagePassengerListings': 'View and manage your passenger listings',
  'nav.myApplications': 'My Applications',
  'nav.viewPassengerApplications': 'View your passenger applications',
  'nav.createPassengerListing': 'Create Passenger Listing',
  'nav.createNewPassengerListing': 'Create a new passenger listing',
  'nav.imSender': "I'm a Sender",
  'nav.searchTravelersSendPackages': 'Search travelers & send packages',
  'nav.imTraveler': "I'm a Traveler",
  'nav.listTripsEarnMoney': 'List trips & earn money',
  'nav.imPassenger': "I'm a Passenger",
  'nav.seeDriverSeatListings': 'See driver seat listings',
  'nav.imDriver': "I'm a Driver",
  'nav.seePassengerRideRequests': 'See passenger ride requests',
  
  // Wallet
  'wallet.addMoney': 'Add Money',
  'wallet.withdrawMoney': 'Withdraw Money',
  'wallet.balance': 'Balance',
  'wallet.transactions': 'Transactions',
  'wallet.depositFunds': 'Deposit Funds',
  'wallet.addBalance': 'Add Balance',
  'wallet.fundWalletDescription': 'Fund your FlexySwap wallet to send package requests instantly. Deposits are processed securely via Stripe and tracked in your wallet history.',
  'wallet.currentBalance': 'Current Balance',
  'wallet.chooseAmount': 'Choose Amount',
  'wallet.customAmount': 'Custom Amount',
  'wallet.minimumDeposit': 'Minimum deposit is CAD 10.00. Deposits are final once confirmed.',
  'wallet.cardHolderName': 'Card Holder Name',
  'wallet.email': 'Email',
  'wallet.savedCards': 'Saved Cards',
  'wallet.loadingCards': 'Loading cards...',
  'wallet.noSavedCards': 'No saved cards yet. Add a card during payment to save it.',
  'wallet.addNewCard': '+ Add New Card',
  'wallet.cardDetails': 'Card Details',
  'wallet.cardDetailsReady': 'Card details ready',
  'wallet.enterCardInfo': 'Enter card info',
  'wallet.readyToCharge': 'Ready to charge this card.',
  'wallet.openSecurePanel': 'Open the secure panel to type card number, expiry, and CVC.',
  'wallet.editCard': 'Edit card',
  'wallet.enterCard': 'Enter card',
  'wallet.addAmount': 'Add {{amount}}',
  'wallet.processing': 'Processing...',
  'wallet.poweredByStripe': "Powered securely by Stripe. Your card details never touch FlexySwap's servers.",
  'wallet.secure': 'Secure',
  'wallet.enterCardDetails': 'Enter card details',
  'wallet.close': 'Close',
  'wallet.cardDataEncrypted': 'Card data is encrypted and processed by Stripe. FlexySwap never sees or stores your card number.',
  'wallet.cardNumber': 'Card number',
  'wallet.expiry': 'Expiry',
  'wallet.cvc': 'CVC',
  'wallet.saveCardForFuturePayments': 'Save card for future payments',
  'wallet.cardDetailsEncrypted': 'Your card details are encrypted and securely stored by Stripe. You can delete saved cards anytime.',
  'wallet.done': 'Done',
  'wallet.cardInformation': 'Card information',
  'wallet.nameOnCard': 'Name on card',
  'wallet.mmYy': 'MM/YY',
  'wallet.billingAddress': 'Billing address',
  'wallet.countryOrRegion': 'Country or region',
  'wallet.postalCode': 'Postal code',
  'wallet.savePaymentDetails': 'Save payment details to FlexySwap for future purchases',
  'wallet.withdrawFunds': 'Withdraw Funds',
  'wallet.cashOutEarnings': 'Cash Out Earnings',
  'wallet.transferBalanceDescription': 'Transfer your FlexySwap balance to your connected Stripe account. Ensure your payout details are verified to avoid processing delays.',
  'wallet.availableBalance': 'Available Balance',
  'wallet.setupWithdrawalAccount': 'Setup Withdrawal Account',
  'wallet.connectStripeDescription': "Connect your Stripe account to enable withdrawals. You'll need to complete Stripe's onboarding process to verify your identity and banking details.",
  'wallet.setupAccount': 'Setup Account',
  'wallet.settingUp': 'Setting up...',
  'wallet.checkStatus': 'Check Status',
  'wallet.checking': 'Checking...',
  'wallet.accountReadyForWithdrawals': 'Account ready for withdrawals',
  'wallet.accountSetupInProgress': 'Account setup in progress. Please complete setup if needed.',
  'wallet.completeAccountSetup': 'Complete Account Setup',
  'wallet.refreshAccountStatus': 'Refresh Account Status',
  'wallet.withdrawalAccount': 'Withdrawal Account',
  'wallet.accountId': 'Account ID:',
  'wallet.payouts': 'Payouts:',
  'wallet.enabled': 'Enabled',
  'wallet.disabled': 'Disabled',
  'wallet.pending': 'Pending',
  'wallet.changeWithdrawalAccount': 'Change Withdrawal Account',
  'wallet.withdrawalAmount': 'Withdrawal Amount',
  'wallet.quickAmounts': 'Quick amounts',
  'wallet.withdraw': 'Withdraw {{amount}}',
  'wallet.withdrawButton': 'Withdraw',
  'wallet.submitting': 'Submitting...',
  'wallet.withdrawalsProcessed': 'Withdrawals are processed through Stripe Connect. Ensure your payout account is fully verified. Processing times may vary based on your bank.',
  'wallet.stripeTestInstructions': 'Stripe Test Instructions',
  'wallet.connectUpdateInstructions': 'Click "Connect / update" to open Stripe\'s onboarding. Use test data from Stripe Docs (e.g., country United States, business type Individual).',
  'wallet.bankingInfoInstructions': 'When prompted for banking info, enter routing number 110000000 and account number 000123456789.',
  'wallet.afterSubmittingInstructions': 'After submitting, click "Check status" to refresh the connection state, then request a withdrawal.',
  'wallet.checkingAccountStatus': 'Checking account status...',
  'wallet.payoutAccount': 'Payout Account',
  'wallet.notConnected': 'Not connected',
  'wallet.connected': 'Connected',
  'wallet.connectUpdate': 'Connect / update',
  'wallet.amount': 'Amount',
  'wallet.withdrawalsLimited': 'Withdrawals are limited to your available balance.',
  'wallet.stripeConnectReturn.accountCreatedSuccessfully': 'Your Account Has Been Successfully Created!',
  'wallet.stripeConnectReturn.accountReady': 'Your Stripe Connect account is ready. You can now make withdrawal transactions.',
  'wallet.stripeConnectReturn.returnToMobileApp': 'You Can Return to the Mobile App',
  'wallet.stripeConnectReturn.appWillOpen': 'The app will open automatically. If it doesn\'t open, click the button below.',
  'wallet.stripeConnectReturn.openApp': 'Open App',
  'wallet.stripeConnectReturn.redirectingToWallet': 'Redirecting to your wallet...',
  'wallet.stripeConnectRefresh.additionalInfoRequired': 'Additional Information Required',
  'wallet.stripeConnectRefresh.completeSetup': 'We need additional information to complete your account. Please complete the setup.',
  'wallet.stripeConnectRefresh.redirectingToSetup': 'Redirecting to account setup...',
  
  // Common
  'common.back': 'Back',
  'common.close': 'Close',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.submit': 'Submit',
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.confirm': 'Confirm',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.sort': 'Sort',
  'common.clear': 'Clear',
  'common.apply': 'Apply',
  'common.reset': 'Reset',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.done': 'Done',
  'common.select': 'Select',
  'common.all': 'All',
  'common.none': 'None',
  'common.required': 'Required',
  'common.optional': 'Optional',
  'common.at': 'at',
  'common.unknownUser': 'Unknown User',
  'common.notAvailable': 'N/A',
  'common.pending': 'Pending',
  'common.accepted': 'Accepted',
  'common.rejected': 'Rejected',
  'common.completed': 'Completed',
  'common.delivered': 'Delivered',
  'common.cancelled': 'Cancelled',
  'common.unknown': 'Unknown',
  
  // Language
  'language.english': 'English',
  'language.french': 'Français',
  'language.selectLanguage': 'Select Language',
  
  // Auth
  'auth.pleaseSignIn': 'Please sign in to manage your wallet balance.',
  'auth.goToLogin': 'Go to login',
  'auth.signIn': 'Sign in',
  'auth.signUp': 'Sign up',
  'auth.createAccount': 'Create account',
  
  // Wallet additional
  'wallet.toWallet': 'to wallet',
  'wallet.pleaseSignIn': 'Please sign in to manage your wallet balance.',
  'wallet.depositSuccessful': 'Deposit successful. Your wallet balance will update shortly.',
  'wallet.paymentFailed': 'Payment failed. Please try again.',
  'wallet.stripeClientSecretMissing': 'Stripe client secret missing.',
  'wallet.paymentReferenceMissing': 'Payment reference missing.',
  'wallet.failedToCreateCustomer': 'Failed to create customer',
  'wallet.selectedCardNotAssociated': 'Selected card is not associated with your account. Please select a different card or add a new one.',
  'wallet.secureCardEntryNotReady': 'Secure card entry is not ready yet. Please wait a moment and try again.',
  'wallet.deleteCardConfirm': 'Are you sure you want to delete card ending in {{last4}}?',
  'wallet.customerIdNotFound': 'Customer ID not found',
  'wallet.cardDeletedSuccessfully': 'Card deleted successfully',
  'wallet.failedToDeleteCard': 'Failed to delete card',
  'wallet.minimumDepositAmount': 'Please enter at least CAD 10.00 to continue.',
  'wallet.maximumDepositAmount': 'Maximum deposit amount is CAD 10,000.00.',
  'wallet.mustBeLoggedIn': 'You must be logged in to deposit funds.',
  'wallet.stripeNotAvailableInCountry': 'Stripe payments are not available in {{country}}. Please update your profile with a supported country.',
  'wallet.unableToLoadStripe': 'Unable to load Stripe securely. Please refresh the page or try again later.',
  'wallet.addCard': 'Add card',
  'wallet.email': 'Email',
  'wallet.email': 'Email',
  'wallet.pleaseEnterAtLeast': 'Please enter at least CAD 10.00 to continue.',
  'wallet.maximumDepositAmount': 'Maximum deposit amount is CAD 10,000.00.',
  'wallet.mustBeLoggedIn': 'You must be logged in to deposit funds.',
  'wallet.stripePaymentsNotAvailable': 'Stripe payments are not available in {country}. Please update your profile with a supported country.',
  'wallet.cardDeletedSuccessfully': 'Card deleted successfully',
  'wallet.failedToDeleteCard': 'Failed to delete card',
  'wallet.customerIdNotFound': 'Customer ID not found',
  
  // Home Page
  'home.packageSwap': 'Package swap',
  'home.sendPackagesAnywhere': 'Send packages anywhere with FlexySwap.',
  'home.flexyRide': 'Flexy Ride',
  'home.findRidesAnywhere': 'Find Rides Anywhere',
  'home.imSender': "I'm a Sender",
  'home.imTraveler': "I'm a Traveler",
  'home.imDriver': "I'm a Driver",
  'home.imPassenger': "I'm a Passenger",
  'home.whatIsFlexySwap': 'What is FlexySwap?',
  'home.flexySwapDescription': 'FlexySwap is a trusted community marketplace that connects travelers who have extra luggage space with people who need to send small items across the world, and drivers with passengers looking to share rides. Together we turn unused luggage allowance and empty car seats into a convenient, affordable, and social delivery and transportation network.',
  'home.ourMission': 'Our Mission',
  'home.missionDescription': 'Build a global, peer-to-peer logistics and transportation network that empowers travelers to monetize their journey and gives senders a faster, more personal, and cost-effective way to move items internationally, while connecting drivers and passengers for shared rides.',
  'home.ourVision': 'Our Vision',
  'home.visionDescription': 'Become the world\'s leading peer-to-peer logistics and ride-sharing platform, making global delivery and transportation as simple and social as catching a ride with a friend.',
  'home.whyFlexySwap': 'Why FlexySwap',
  'home.theProblemWeSolve': 'The Problem We Solve',
  'home.forTravelers': 'For Travelers',
  'home.travelersProblem': 'Up to 70% of travelers have unused luggage weight allowance, which becomes a wasted asset. Many also come home with leftover foreign currency that sits idle.',
  'home.forSenders': 'For Senders',
  'home.sendersProblem': 'International shipping for small packages is slow, expensive, and impersonal. Traditional couriers often charge premium rates for even the simplest deliveries.',
  'home.forDrivers': 'For Drivers',
  'home.driversProblem': 'Many drivers travel with empty seats in their vehicles, missing opportunities to offset fuel costs and make their trips more economical. Long-distance drives can be expensive and lonely.',
  'home.forPassengers': 'For Passengers',
  'home.passengersProblem': 'Finding affordable and convenient transportation for long-distance trips can be challenging. Traditional options like buses or trains are often expensive, inflexible, or don\'t go to your exact destination.',
  'home.theFlexySwapSolution': 'The FlexySwap Solution',
  'home.solutionDescription': 'FlexySwap is built on a simple, powerful idea: why fly with empty suitcase space when someone nearby needs to send something to your destination?',
  'home.solutionDescriptionRide': 'FlexySwap is built on a simple, powerful idea: why drive with empty seats when someone nearby needs a ride to your destination?',
  'home.howItWorks': 'How it works',
  'home.simpleSteps': 'Simple steps to make every swap seamless',
  'home.stepsDescription': 'Travelers and senders follow the same, secure flow to keep deliveries clear.',
  'home.stepsDescriptionRide': 'Drivers and passengers follow the same, secure flow to keep rides smooth.',
  'home.listATrip': 'List a Trip',
  'home.listATripDescription': 'A traveler posts their route, date, and luggage space on FlexySwap.',
  'home.listARide': 'List a Ride',
  'home.listARideDescription': 'A driver posts their route, date, and available seats on FlexySwap.',
  'home.findAMatch': 'Find a Match',
  'home.findAMatchDescription': 'A sender searches for a traveler headed to the right destination.',
  'home.findAMatchRide': 'Find a Match',
  'home.findAMatchRideDescription': 'A passenger searches for a driver headed to the right destination.',
  'home.connectAgree': 'Connect & Agree',
  'home.connectAgreeDescription': 'Both parties chat securely in the app to confirm package details.',
  'home.connectAgreeRide': 'Connect & Agree',
  'home.connectAgreeRideDescription': 'Both parties chat securely in the app to confirm ride details.',
  'home.secureTheDeal': 'Secure the Deal',
  'home.secureTheDealDescription': 'The sender pays through FlexySwap\'s escrow for protected delivery.',
  'home.secureTheDealRide': 'Secure the Deal',
  'home.secureTheDealRideDescription': 'The passenger pays through FlexySwap\'s escrow for protected ride.',
  'home.deliverEarn': 'Deliver & Earn',
  'home.deliverEarnDescription': 'The traveler hands off the item, confirms delivery, and gets paid.',
  'home.completeEarn': 'Complete & Earn',
  'home.completeEarnDescription': 'The driver completes the ride, passenger confirms arrival, and driver gets paid.',
  'home.ourCoreFeatures': 'Our core features',
  'home.everythingYouNeed': 'Everything you need for secure, social deliveries',
  'home.everythingYouNeedRide': 'Everything you need for secure, social rides',
  'home.featuresDescription': 'Built-in tools keep both travelers and senders confident every step of the swap.',
  'home.featuresDescriptionRide': 'Built-in tools keep both drivers and passengers confident every step of the ride.',
  'home.peerToPeerNetwork': 'Peer-to-Peer Network',
  'home.peerToPeerDescription': 'A global community shipping alternative that connects real people.',
  'home.peerToPeerDescriptionRide': 'A global community ride-sharing network that connects real people.',
  'home.secureMessaging': 'Secure Messaging',
  'home.secureMessagingDescription': 'Chat safely without sharing private contact details.',
  'home.escrowPayment': 'Escrow Payment',
  'home.escrowPaymentDescription': 'Protected transactions keep funds safe until delivery is confirmed.',
  'home.escrowPaymentDescriptionRide': 'Protected transactions keep funds safe until ride is completed.',
  'home.reviewSystem': 'Review System',
  'home.reviewSystemDescription': 'Trust the network with community ratings after every swap.',
  'home.reviewSystemDescriptionRide': 'Trust the network with community ratings after every ride.',
  'home.currencySwap': 'Currency Swap',
  'home.currencySwapDescription': 'Easily exchange leftover foreign currency with locals on the route.',
  'home.globalReach': 'Global Reach',
  'home.globalReachDescription': 'Connect with travelers and senders worldwide for international routes.',
  'home.globalReachDescriptionRide': 'Connect with drivers and passengers worldwide for international routes.',
  'home.swapEarn': 'Swap & earn',
  'home.welcomeBack': 'Welcome back',
  'home.driveWhenever': 'Drive whenever you want, earn what you need.',
  'home.listNextTrip': 'List your next trip and keep earnings flowing.',
  'home.pickupPackages': 'Pick up packages near you and drop them off along your route. FlexySwap connects you with trusted senders so every hand-off feels simple and safe.',
  'home.publishTrip': 'Publish a fresh trip, check incoming requests, and stay synced with the console you already know from the app.',
  'home.getStarted': 'Get started',
  'home.listNewTrip': 'List a new trip',
  'home.alreadyHaveAccount': 'Already have an account? Sign in',
  'home.openSenderConsole': 'Open sender console',
  'home.handOffMoment': 'Hand-off moment',
  'home.yourTools': 'Your tools',
  'home.yourToolsRide': 'Your tools',
  'home.swapSafely': 'Swap safely wherever your route begins.',
  'home.jumpBack': 'Jump back into your requests and trips.',
  'home.jumpBackRide': 'Jump back into your ride requests and listings.',
  'home.meetUpCurbside': 'Meet up curbside, at the airport, or in front of your traveler\'s car. FlexySwap connects senders and travelers with verified identities and live chat, so every package swap feels as easy as a friendly hand-off.',
  'home.reviewPending': 'Review pending swaps, track payouts, and coordinate new routes directly from the consoles you already use.',
  'home.reviewPendingRide': 'Review pending ride requests, track earnings, and coordinate new routes directly from the consoles you already use.',
  'home.findTraveler': 'Find a traveler',
  'home.viewMyTrips': 'View my trips',
  'home.viewMyRides': 'View my rides',
  'home.offerToCarry': 'Offer to carry',
  'home.manageRequests': 'Manage requests',
  'home.manageRideRequests': 'Manage ride requests',
  'home.mobileApp': 'Mobile App',
  'home.takeFlexySwap': 'Take FlexySwap with you',
  'home.downloadApp': 'Download our mobile app and manage your trips, requests, and deliveries from anywhere.',
  'home.dateAndTime': 'Date and Time',
  'home.resultsWithinDays': 'Results will include trips within ±3 days of the selected date.',
  'home.signInToFindTrips': 'Sign in to find trips',
  'home.findTrips': 'Find trips',
  'home.from': 'From',
  'home.to': 'To',
  'home.fromPlaceholder': 'Airport, bus station, hotel...',
  'home.toPlaceholder': 'Drop-off point',

  // Sender Trips (web sender console)
  'senderTrips.title': 'Sender console',
  'senderTrips.subtitle': 'Where do you need to send a package?',
  'senderTrips.ctaLabel': 'Search travelers',
  'senderTrips.showAllOnMap': 'Show all trips on map',
  'senderTrips.seeActiveTravelers': 'See active travelers below',
  'senderTrips.signInTitle': 'Sign in to view your travelers',
  'senderTrips.signInDescription': 'Use your FlexySwap credentials to load the trips synced from the mobile app.',
  'senderTrips.emptyTitle': 'No active travelers found yet.',
  'senderTrips.emptySubtitle': 'Want to keep things moving? Create a delivery request or list a trip yourself.',
  'senderTrips.createRequest': 'Create delivery request',
  'senderTrips.listNewTrip': 'List a new trip',
  'senderTrips.primaryAction': 'Request',
  'senderTrips.secondaryAction': 'View details',
  'senderTrips.mapTitle': 'Sender listings map view',
  'senderTrips.disableOwn': 'This listing belongs to you',
  'senderTrips.disableAlreadyRequested': 'You have already sent a request to this listing',

  // Traveler Trips (web traveler console)
  'travelerTrips.title': 'Traveler console',
  'travelerTrips.subtitle': 'Where are you traveling to?',
  'travelerTrips.ctaLabel': 'Search senders',
  'travelerTrips.showAllOnMap': 'Show all trips on map',
  'travelerTrips.seeActiveSenders': 'See active senders below',
  'travelerTrips.signInTitle': 'Please sign in to view senders',
  'travelerTrips.signInDescription': 'FlexySwap mobile data is available once you log in with your existing account.',
  'travelerTrips.emptyTitle': 'No sender requests found right now.',
  'travelerTrips.emptySubtitle': 'You can still keep the swap alive—publish a trip or request a delivery directly.',
  'travelerTrips.listNewTrip': 'List a new trip',
  'travelerTrips.createRequest': 'Create delivery request',
  'travelerTrips.primaryAction': 'Send offer',
  'travelerTrips.secondaryAction': 'View details',
  'travelerTrips.mapTitle': 'Traveler listings map view',
  'travelerTrips.disableOwn': 'This listing belongs to you',
  'travelerTrips.disableAlreadyRequested': 'You have already sent a request to this listing',

  // Trip result cards
  'tripCard.capacityLeft': 'Capacity left:',
  'tripCard.price': 'Price:',
  'tripCard.material': 'Material:',
  'tripCard.deliveryMethod': 'Delivery method:',
  'tripCard.contactForPrice': 'Contact for price',
  'tripCard.scheduleTbd': 'Schedule to be confirmed',
  'tripCard.flexyUser': 'Flexy user',

  // Trip detail page
  'tripDetail.tripIdNotFound': 'Trip ID not found',
  'tripDetail.tripNotFound': 'Trip not found',
  'tripDetail.failedToLoad': 'Failed to load trip details',
  'tripDetail.notFoundDescription': 'The trip you\'re looking for doesn\'t exist or has been removed.',
  'tripDetail.loading': 'Loading trip details...',
  'tripDetail.unverified': 'Unverified',
  'tripDetail.reviews': '({{count}} reviews)',
  'tripDetail.completedTrips': '{{count}} completed trips',
  'tripDetail.viewProfile': 'View Profile',
  'tripDetail.senderDeliveries': 'Sender Deliveries',
  'tripDetail.travelerDeliveries': 'Traveler Deliveries',
  'tripDetail.sendOffer': 'Send Offer',
  'tripDetail.requestDelivery': 'Request Delivery',
  'tripDetail.tripInformation': 'Trip Information',
  'tripDetail.route': 'Route',
  'tripDetail.departure': 'Departure',
  'tripDetail.atTime': 'at {{time}}',
  'tripDetail.tripDetails': 'Trip Details',
  'tripDetail.tripType': 'Trip Type',
  'tripDetail.lookingForSpace': 'Looking for Space',
  'tripDetail.offeringShipping': 'Offering Shipping',
  'tripDetail.materialType': 'Material Type',
  'tripDetail.deliveryMethod': 'Delivery Method',
  'tripDetail.spaceNeeded': 'Space Needed',
  'tripDetail.capacityAvailable': 'Capacity Available',
  'tripDetail.itemDescription': 'Item Description',
  'tripDetail.notesAndRules': 'Notes & Rules',
  'tripDetail.securePaymentProtection': 'Secure Payment Protection',
  'tripDetail.securePaymentText': 'Payments are held securely until delivery is confirmed. Your money is safe with FlexySwap.',

  // Chat
  'chat.title': 'Messages',
  'chat.searchPlaceholder': 'Search conversations...',
  'chat.noConversations': 'No conversations yet',
  'chat.noMessagesYet': 'No messages yet',
  'chat.noMessagesStart': 'No messages yet. Start the conversation!',
  'chat.online': 'Online',
  'chat.offline': 'Offline',
  'chat.seenRecently': 'Seen recently',
  'chat.minutesAgo': '{{count}} min ago',
  'chat.hoursAgo': '{{count}} hours ago',
  'chat.daysAgo': '{{count}} days ago',
  'chat.typing': 'Typing...',
  'chat.photo': 'Photo',
  'chat.file': 'File',
  'chat.sending': 'Sending...',
  'chat.send': 'Send',
  'chat.replyToMessage': 'Reply to message',
  'chat.repliedTo': 'Replied to:',
  'chat.replyingTo': 'Replying to:',
  'chat.inputPlaceholder': 'Send a message...',
  'chat.blockedByUser': 'You are blocked by this user',
  'chat.blockedUser': 'You have blocked this user',
  'chat.selectConversation': 'Select a conversation to start messaging',
  'chat.replyToMessageModalTitle': 'Reply to Message',
  'chat.originalMessage': 'Original Message:',
  'chat.replyPlaceholder': 'Type your reply...',
  'chat.cancel': 'Cancel',
  'chat.reply': 'Reply',
  'chat.thisUser': 'this user',
  'chat.confirmDeleteConversation': 'Are you sure you want to delete this conversation?',
  'chat.failedDeleteConversation': 'Failed to delete conversation',
  'chat.confirmBlockUser': 'Are you sure you want to block {{name}}?',
  'chat.confirmUnblockUser': 'Are you sure you want to unblock {{name}}?',
  'chat.confirmReportUser': 'Are you sure you want to report {{name}}?',
  'chat.userReported': 'User reported successfully',

  // Request Delivery
  'requestDelivery.editRequest': 'Edit request',
  'requestDelivery.requestDelivery': 'Request delivery',
  'requestDelivery.updateYourDeliveryRequest': 'Update your delivery request',
  'requestDelivery.sendPackagesWorldwide': 'Send packages worldwide with trusted travelers.',
  'requestDelivery.captureYourRoute': 'Capture your route, pickup window, and package details once. FlexySwap matches you with verified travelers who have spare luggage space, protected by escrow payouts and in-app chat.',
  'requestDelivery.airportCityHandoffs': 'Airport & city hand-offs',
  'requestDelivery.photoProofOnDelivery': 'Photo proof on delivery',
  'requestDelivery.viewMyRequests': 'View my requests',
  'requestDelivery.browseTravelerRoutes': 'Browse traveler routes',
  'requestDelivery.avgPickupTime': 'Avg. pickup time',
  'requestDelivery.verifiedTravelers': 'Verified travelers',
  'requestDelivery.routesWeekly': 'Routes weekly',
  'requestDelivery.stepOf': 'Step {{current}} of {{total}}',
  'requestDelivery.routeDestination': 'Route & Destination',
  'requestDelivery.searchOriginAddress': 'Search origin address',
  'requestDelivery.searchDestinationAddress': 'Search destination address',
  'requestDelivery.departure': 'Departure',
  'requestDelivery.date': 'Date',
  'requestDelivery.time': 'Time',
  'requestDelivery.selectDepartureDate': 'Select departure date',
  'requestDelivery.selectDepartureTime': 'Select departure time',
  'requestDelivery.itemDescription': 'Item Description',
  'requestDelivery.describeItems': 'Describe the items you want to send',
  'requestDelivery.itemDescriptionPlaceholder': 'e.g., Documents, Electronics, Clothes...',
  'requestDelivery.spaceNeeded': 'Space Needed',
  'requestDelivery.enterAmount': 'Enter amount',
  'requestDelivery.additionalInformation': 'Additional Information',
  'requestDelivery.notesOptional': 'Notes (Optional)',
  'requestDelivery.notesPlaceholder': 'Any special instructions or details...',
  'requestDelivery.agreements': 'Agreements',
  'requestDelivery.agreeToBeContacted': 'I agree to be contacted via the app for delivery coordination',
  'requestDelivery.acceptTerms': 'I accept the terms and conditions and privacy policy',
  'requestDelivery.summary': 'Summary',
  'requestDelivery.route': 'Route',
  'requestDelivery.notes': 'Notes',
  'requestDelivery.back': 'Back',
  'requestDelivery.next': 'Next',
  'requestDelivery.updating': 'Updating...',
  'requestDelivery.creating': 'Creating...',
  'requestDelivery.updateRequest': 'Update Request',
  'requestDelivery.submitRequest': 'Submit Request',
  'requestDelivery.departureDate': 'Departure date',
  'requestDelivery.pickADay': 'Pick a day that fits your route',
  'requestDelivery.useQuickSuggestions': 'Use quick suggestions or choose from the calendar below.',
  'requestDelivery.quickPicks': 'Quick picks',
  'requestDelivery.today': 'Today',
  'requestDelivery.tomorrow': 'Tomorrow',
  'requestDelivery.in3Days': 'In 3 days',
  'requestDelivery.nextWeek': 'Next week',
  'requestDelivery.calendar': 'Calendar',
  'requestDelivery.cancel': 'Cancel',
  'requestDelivery.useThisDate': 'Use this date',
  'requestDelivery.departureTime': 'Departure time',
  'requestDelivery.chooseClearHandoffTime': 'Choose a clear hand-off time',
  'requestDelivery.tapHourThenMinutes': 'Tap an hour, then minutes. Finish with quick confirmation.',
  'requestDelivery.manualAdjust': 'Manual adjust',
  'requestDelivery.hour': 'Hour',
  'requestDelivery.minutes': 'Minutes',
  'requestDelivery.adjustsInMinuteSteps': 'Adjusts in {step}-minute steps',
  'requestDelivery.useThisTime': 'Use this time',
  'requestDelivery.pleaseSelectBothAddresses': 'Please select both origin and destination addresses',
  'requestDelivery.originDestinationCannotBeSame': 'Origin and destination cannot be the same',
  'requestDelivery.pleaseSelectDateAndTime': 'Please select both departure date and time',
  'requestDelivery.pleaseDescribeItems': 'Please describe the items you want to send',
  'requestDelivery.pleaseEnterValidSpace': 'Please enter a valid space amount',
  'requestDelivery.notesCannotExceed': 'Notes cannot exceed 200 characters',
  'requestDelivery.pleaseAcceptBothAgreements': 'Please accept both agreements to continue',
  'requestDelivery.pleaseLogIn': 'Please log in to create a request',
  'requestDelivery.requestUpdatedSuccessfully': 'Request updated successfully!',
  'requestDelivery.requestCreatedSuccessfully': 'Request created successfully!',
  'requestDelivery.failedToUpdateRequest': 'Failed to update request. Please try again.',
  'requestDelivery.failedToCreateRequest': 'Failed to create request. Please try again.',
  
  // Incoming Requests
  'incomingRequests.incomingRequests': 'Incoming Requests',
  'incomingRequests.manageRequestsFromTravelers': 'Manage requests from travelers for your delivery listings',
  'incomingRequests.noDeliveryListingsYet': 'No delivery listings yet',
  'incomingRequests.createDeliveryRequest': 'Create a delivery request to start receiving requests from travelers',
  'incomingRequests.createRequest': 'Create Request',
  'incomingRequests.route': 'Route',
  'incomingRequests.departure': 'Departure',
  'incomingRequests.itemDescription': 'Item Description',
  'incomingRequests.spaceNeeded': 'Space Needed',
  'incomingRequests.pending': 'Pending',
  'incomingRequests.accepted': 'Accepted',
  'incomingRequests.total': 'Total',
  'incomingRequests.done': 'Done',
  'incomingRequests.view': 'View',
  'incomingRequests.edit': 'Edit',
  'incomingRequests.delete': 'Delete',
  'incomingRequests.completed': 'Completed',
  'incomingRequests.itemDescription': 'Item Description',
  'incomingRequests.spaceNeeded': 'Space Needed',
  'incomingRequests.notes': 'Notes',
  'incomingRequests.accept': 'Accept',
  'incomingRequests.reject': 'Reject',
  'incomingRequests.areYouSureReject': 'Are you sure you want to reject this request?',
  'incomingRequests.requestRejected': 'Request rejected.',
  'incomingRequests.failedToRejectRequest': 'Failed to reject request. Please try again.',
  'incomingRequests.requestAcceptedSuccessfully': 'Request accepted successfully!',
  'incomingRequests.failedToAcceptRequest': 'Failed to accept request. Please try again.',
  'incomingRequests.areYouSureDeleteTrip': 'Are you sure you want to delete this trip? This action cannot be undone and will also delete all associated requests.',
  'incomingRequests.tripDeletedSuccessfully': 'Trip deleted successfully.',
  'incomingRequests.failedToDeleteTrip': 'Failed to delete trip. Please try again.',
  'incomingRequests.pleaseLogInToView': 'Please log in to view your incoming requests',
  'incomingRequests.goToLogin': 'Go to login',
  
  // My Requests
  'myRequests.myRequests': 'My Requests',
  'myRequests.viewAndManageRequests': 'View and manage your delivery requests to travelers',
  'myRequests.noRequestsYet': 'No requests yet',
  'myRequests.haventSentAnyRequests': 'You haven\'t sent any delivery requests to travelers yet',
  'myRequests.tripOwner': 'Trip Owner',
  'myRequests.item': 'Item',
  'myRequests.status.pending': 'Pending',
  'myRequests.status.accepted': 'Accepted',
  'myRequests.status.rejected': 'Rejected',
  'myRequests.status.completed': 'Completed',
  'myRequests.status.delivered': 'Delivered',
  'myRequests.status.cancelled': 'Cancelled',
  'myRequests.waitingForDelivery': 'Waiting for delivery from {{name}}',
  'myRequests.confirmPayment': 'Confirm Payment',
  'myRequests.rate': 'Rate',
  'myRequests.reviewed': 'Reviewed',
  'myRequests.cancelRequest': 'Cancel Request',
  'myRequests.message': 'Message',
  'myRequests.areYouSureCancel': 'Are you sure you want to cancel this request?',
  'myRequests.requestCancelledSuccessfully': 'Request cancelled successfully.',
  'myRequests.failedToCancelRequest': 'Failed to cancel request. Please try again.',
  'myRequests.pleaseLogInToView': 'Please log in to view your requests',
  'myRequests.confirmPaymentTitle': 'Confirm Payment',
  'myRequests.hasReportedDelivered': '{{name}} has reported that your package was delivered. Would you like to release the payment?',
  'myRequests.subtotal': 'Subtotal',
  'myRequests.fees15': 'Fees (15%)',
  'myRequests.total': 'Total',
  'myRequests.no': 'No',
  'myRequests.yes': 'Yes',
  'myRequests.paymentConfirmed': 'Payment confirmed. Delivery completed successfully!',
  'myRequests.failedToConfirmPayment': 'Failed to confirm payment. Please try again.',
  'myRequests.prev': 'Prev',
  'myRequests.next': 'Next',
  'myRequests.thisTraveler': 'This traveler',
  'myRequests.route': 'Route',
  'myRequests.departure': 'Departure',
  'myRequests.space': 'Space',
  'myRequests.price': 'Price',
  'myRequests.notes': 'Notes',
  
  // Traveler Trip Requests
  'travelerTripRequests.tripRequests': 'Trip Requests',
  'travelerTripRequests.manageRequestsForListing': 'Manage requests for your travel listing',
  'travelerTripRequests.backToIncomingRequests': 'Back to Incoming Requests',
  'travelerTripRequests.availableSpace': 'Available Space',
  'travelerTripRequests.requests': 'Requests',
  'travelerTripRequests.noRequestsYetForTrip': 'No requests yet for this trip',
  'travelerTripRequests.tripNotFound': 'Trip not found',
  'travelerTripRequests.failedToLoadTrip': 'Failed to load trip',
  'travelerTripRequests.theTravelerIsOffering': 'The traveler is offering to carry your package "{{item}}" 📦',
  'travelerTripRequests.waitingForDelivery': 'Waiting for delivery from {{name}}',
  'travelerTripRequests.waitingForYourConfirmation': 'Waiting for your confirmation',
  'travelerTripRequests.hasMarkedAsDelivered': '{{name}} {{email}} has marked the item as delivered. Please confirm receipt.',
  'travelerTripRequests.confirmReceived': 'Confirm Received',
  'travelerTripRequests.contact': 'Contact',
  'travelerTripRequests.requestCompletedSuccessfully': 'Request completed successfully!',
  'travelerTripRequests.confirmPaymentTitle': 'Confirm Payment',
  'travelerTripRequests.hasReportedDelivered': '{{name}} has reported that your package was delivered. Would you like to release the payment?',
  'travelerTripRequests.subtotal': 'Subtotal',
  'travelerTripRequests.fees15': 'Fees (15%)',
  'travelerTripRequests.total': 'Total',
  'travelerTripRequests.no': 'No',
  'travelerTripRequests.yes': 'Yes',
  'travelerTripRequests.paymentConfirmed': 'Payment confirmed. Delivery completed successfully!',
  'travelerTripRequests.failedToConfirmPayment': 'Failed to confirm payment. Please try again.',
  'travelerTripRequests.pleaseLogInToReview': 'Please log in to submit a review.',
  'travelerTripRequests.requesterInfoMissing': 'Requester information is missing.',
  'travelerTripRequests.rejectRequest': 'Reject Request',
  'travelerTripRequests.acceptRequest': 'Accept Request',
  'travelerTripRequests.areYouSureReject': 'Are you sure you want to reject this request? This action cannot be undone.',
  'travelerTripRequests.areYouSureAccept': 'Are you sure you want to accept this request?',
  'travelerTripRequests.reject': 'Reject',
  'travelerTripRequests.accept': 'Accept',
  'travelerTripRequests.cancel': 'Cancel',
  'travelerTripRequests.requestAcceptedSuccessfully': 'Request accepted successfully!',
  'travelerTripRequests.otherRequestsAutomaticallyRejected': '{count} other request(s) automatically rejected.',
  'travelerTripRequests.failedToAcceptRequest': 'Failed to accept request. Please try again.',
  'travelerTripRequests.requestRejected': 'Request rejected.',
  'travelerTripRequests.failedToRejectRequest': 'Failed to reject request. Please try again.',
  'travelerTripRequests.spaceNeeded': 'Space Needed',
  'travelerTripRequests.price': 'Price',
  'travelerTripRequests.deliveryMethod': 'Delivery Method',
  'travelerTripRequests.byRoad': 'By Road',
  'travelerTripRequests.byRail': 'By Rail',
  'travelerTripRequests.byAir': 'By Air',
  'travelerTripRequests.notes': 'Notes',
  'travelerTripRequests.item': 'Item',
  'travelerTripRequests.thisItem': 'this item',
  'travelerTripRequests.departure': 'Departure',
  
  // Navbar
  'nav.trips': 'Trips',
  'nav.driver': 'Driver',
  'nav.passenger': 'Passenger',
  'nav.asSender': 'As Sender',
  'nav.asTraveler': 'As Traveler',
  'nav.imASender': 'I\'m a Sender',
  'nav.imATraveler': 'I\'m a Traveler',
  'nav.imAPassenger': 'I\'m a Passenger',
  'nav.imADriver': 'I\'m a Driver',
  'nav.searchTravelersSendPackages': 'Search travelers & send packages',
  'nav.listTripsEarnMoney': 'List trips & earn money',
  'nav.seeDriverSeatListings': 'See driver seat listings',
  'nav.seePassengerRideRequests': 'See passenger ride requests',
  'nav.flexyRide': 'Flexy Ride',
  'nav.browseAsSender': 'Browse as Sender',
  'nav.browseAsTraveler': 'Browse as Traveler',
  'nav.browseAsDriver': 'Browse as Driver',
  'nav.browseAsPassenger': 'Browse as Passenger',
  'nav.welcomeBack': 'Welcome back',
  'nav.createAccount': 'Create account',
  'nav.mySeatListings': 'My Seat Listings',
  'nav.viewAndManageYourSeatListings': 'View and manage your seat listings',
  'nav.myRequests': 'My Requests',
  'nav.viewYourSeatRequests': 'View your seat requests',
  'nav.createSeatListing': 'Create Seat Listing',
  'nav.listANewSeat': 'List a new seat',
  'nav.myPassengerListings': 'My Passenger Listings',
  'nav.viewAndManageYourPassengerListings': 'View and manage your passenger listings',
  'nav.myApplications': 'My Applications',
  'nav.viewYourPassengerApplications': 'View your passenger applications',
  'nav.createPassengerListing': 'Create Passenger Listing',
  'nav.createANewPassengerListing': 'Create a new passenger listing',
  
  // Traveler My Requests
  'travelerMyRequests.myRequests': 'My Requests',
  'travelerMyRequests.viewAndManageRequests': 'View and manage your delivery requests to senders',
  'travelerMyRequests.noRequestsYet': 'No requests yet',
  'travelerMyRequests.haventSentAnyRequests': 'You haven\'t sent any delivery requests to senders yet',
  'travelerMyRequests.browseSenderListings': 'Browse Sender Listings',
  'travelerMyRequests.pleaseLogInToView': 'Please log in to view your requests',
  'travelerMyRequests.goToLogin': 'Go to login',
  'travelerMyRequests.tripOwner': 'Trip Owner',
  'travelerMyRequests.item': 'Item',
  'travelerMyRequests.route': 'Route',
  'travelerMyRequests.departure': 'Departure',
  'travelerMyRequests.space': 'Space',
  'travelerMyRequests.price': 'Price',
  'travelerMyRequests.notes': 'Notes',
  'travelerMyRequests.delivery': 'Delivery',
  'travelerMyRequests.deliveryInProgress': 'Delivery in progress',
  'travelerMyRequests.markAsDelivered': 'Mark as Delivered',
  'travelerMyRequests.cancelRequest': 'Cancel Request',
  'travelerMyRequests.message': 'Message',
  'travelerMyRequests.rate': 'Rate',
  'travelerMyRequests.reviewed': 'Reviewed',
  'travelerMyRequests.waitingForSenderConfirmation': 'Waiting for sender to confirm payment and receipt...',
  'travelerMyRequests.areYouSureCancel': 'Are you sure you want to cancel this request?',
  'travelerMyRequests.requestCancelledSuccessfully': 'Request cancelled successfully.',
  'travelerMyRequests.failedToCancelRequest': 'Failed to cancel request. Please try again.',
  'travelerMyRequests.markAsDeliveredConfirm': 'Mark this item as delivered?',
  'travelerMyRequests.itemMarkedAsDelivered': 'Item marked as delivered. Waiting for sender confirmation.',
  'travelerMyRequests.failedToMarkAsDelivered': 'Failed to mark as delivered. Please try again.',
  'travelerMyRequests.pleaseLogInToRate': 'Please log in to rate other users.',
  'travelerMyRequests.tripOwnerInfoMissing': 'Trip owner information is missing.',
  'travelerMyRequests.alreadyReviewed': 'You have already reviewed this user.',
  'travelerMyRequests.failedToOpenReviewModal': 'Failed to open review modal. Please try again.',
  'travelerMyRequests.prev': 'Prev',
  'travelerMyRequests.next': 'Next',
  
  // Sender Trip Requests
  'senderTripRequests.tripRequests': 'Trip Requests',
  'senderTripRequests.manageRequestsForListing': 'Manage requests for your delivery listing',
  'senderTripRequests.backToMyListings': 'Back to My Listings',
  'senderTripRequests.tripNotFound': 'Trip not found',
  'senderTripRequests.failedToLoadTrip': 'Failed to load trip',
  'senderTripRequests.route': 'Route',
  'senderTripRequests.departure': 'Departure',
  'senderTripRequests.itemDescription': 'Item Description',
  'senderTripRequests.requests': 'Requests',
  'senderTripRequests.pending': 'Pending',
  'senderTripRequests.accepted': 'Accepted',
  'senderTripRequests.noRequestsYetForTrip': 'No requests yet for this trip',
  'senderTripRequests.item': 'Item',
  'senderTripRequests.spaceNeeded': 'Space Needed',
  'senderTripRequests.price': 'Price',
  'senderTripRequests.notes': 'Notes',
  'senderTripRequests.accept': 'Accept',
  'senderTripRequests.reject': 'Reject',
  'senderTripRequests.contactTraveler': 'Contact Traveler',
  'senderTripRequests.contact': 'Contact',
  'senderTripRequests.rate': 'Rate',
  'senderTripRequests.reviewed': 'Reviewed',
  'senderTripRequests.theSenderRequests': 'The sender requests that you transport the package "{{item}}" 📦',
  'senderTripRequests.thisItem': 'this item',
  'senderTripRequests.requestAccepted': 'Request accepted. Waiting for delivery...',
  'senderTripRequests.markAsDelivered': 'Mark as Delivered',
  'senderTripRequests.confirmReceivedApprovalPending': 'Confirm Received approval is pending',
  'senderTripRequests.requestCompletedSuccessfully': 'Request completed successfully!',
  'senderTripRequests.rejectRequest': 'Reject Request',
  'senderTripRequests.acceptRequest': 'Accept Request',
  'senderTripRequests.areYouSureReject': 'Are you sure you want to reject this request? This action cannot be undone.',
  'senderTripRequests.areYouSureAccept': 'Are you sure you want to accept this request?',
  'senderTripRequests.cancel': 'Cancel',
  'senderTripRequests.requestAcceptedSuccessfully': 'Request accepted successfully!',
  'senderTripRequests.otherRequestsAutomaticallyRejected': '{count} other request(s) automatically rejected.',
  'senderTripRequests.failedToAcceptRequest': 'Failed to accept request. Please try again.',
  'senderTripRequests.requestRejected': 'Request rejected.',
  'senderTripRequests.failedToRejectRequest': 'Failed to reject request. Please try again.',
  'senderTripRequests.itemMarkedAsDelivered': 'Item marked as delivered. Waiting for sender confirmation.',
  'senderTripRequests.failedToMarkAsDelivered': 'Failed to mark as delivered. Please try again.',
  'senderTripRequests.confirmPayment': 'Confirm Payment',
  'senderTripRequests.subtotal': 'Subtotal',
  'senderTripRequests.fees15': 'Fees (15%)',
  'senderTripRequests.total': 'Total',
  'senderTripRequests.paymentConfirmed': 'Payment confirmed. Delivery completed successfully!',
  'senderTripRequests.failedToConfirmPayment': 'Failed to confirm payment. Please try again.',
  'senderTripRequests.pleaseLogInToReview': 'Please log in to submit a review.',
  'senderTripRequests.travelerInfoMissing': 'Traveler information is missing.',
  'senderTripRequests.alreadyReviewed': 'You have already reviewed this traveler.',
  'senderTripRequests.failedToOpenReviewModal': 'Failed to open review modal. Please try again.',
  
  // List New Trip
  'listNewTrip.editTrip': 'Edit trip',
  'listNewTrip.listNewTrip': 'List a new trip',
  'listNewTrip.updateTripDetails': 'Update your trip details',
  'listNewTrip.turnSpareLuggageSpace': 'Turn spare luggage space into instant payout.',
  'listNewTrip.publishRouteDescription': 'Publish your route, pickup window, and luggage capacity in minutes. FlexySwap pairs you with vetted senders, keeps messaging in-app, and releases payment once delivery is confirmed.',
  'listNewTrip.globalAirportNetwork': 'Global airport network',
  'listNewTrip.escrowSecuredPayouts': 'Escrow-secured payouts',
  'listNewTrip.viewMyListings': 'View my listings',
  'listNewTrip.checkSenderRequests': 'Check sender requests',
  'listNewTrip.avgEarningsPerTrip': 'Avg. earnings / trip',
  'listNewTrip.communitySwaps': 'Community swaps',
  'listNewTrip.routesListedWeekly': 'Routes listed weekly',
  'listNewTrip.stepOf': 'Step {{current}} of {{total}}',
  'listNewTrip.routeDestination': 'Route & Destination',
  'listNewTrip.searchOriginAddress': 'Search origin address',
  'listNewTrip.searchDestinationAddress': 'Search destination address',
  'listNewTrip.departure': 'Departure',
  'listNewTrip.date': 'Date',
  'listNewTrip.time': 'Time',
  'listNewTrip.selectDepartureDate': 'Select departure date',
  'listNewTrip.selectDepartureTime': 'Select departure time',
  'listNewTrip.deliveryMethod': 'Delivery Method',
  'listNewTrip.byRail': 'By Rail',
  'listNewTrip.byAir': 'By Air',
  'listNewTrip.byRoad': 'By Road',
  'listNewTrip.availableSpace': 'Available Space',
  'listNewTrip.spaceNeeded': 'Space Needed',
  'listNewTrip.enterAmount': 'Enter amount',
  'listNewTrip.pricing': 'Pricing',
  'listNewTrip.pricingMode': 'Pricing Mode',
  'listNewTrip.perUnit': 'Per Unit',
  'listNewTrip.flatPrice': 'Flat Price',
  'listNewTrip.pricePerUnit': 'Price Per Unit (USD)',
  'listNewTrip.enterPricePerUnit': 'Enter price per unit',
  'listNewTrip.flatPriceUsd': 'Flat Price (USD)',
  'listNewTrip.enterFlatPrice': 'Enter flat price',
  'listNewTrip.additionalInformation': 'Additional Information',
  'listNewTrip.notesOptional': 'Notes (Optional)',
  'listNewTrip.anySpecialInstructions': 'Any special instructions or details...',
  'listNewTrip.agreements': 'Agreements',
  'listNewTrip.agreeToBeContacted': 'I agree to be contacted via the app for delivery coordination',
  'listNewTrip.acceptTerms': 'I accept the terms and conditions and privacy policy',
  'listNewTrip.summary': 'Summary',
  'listNewTrip.route': 'Route',
  'listNewTrip.deliveryMethod': 'Delivery Method',
  'listNewTrip.availableSpace': 'Available Space',
  'listNewTrip.pricing': 'Pricing',
  'listNewTrip.notes': 'Notes',
  'listNewTrip.back': 'Back',
  'listNewTrip.next': 'Next',
  'listNewTrip.updating': 'Updating...',
  'listNewTrip.creating': 'Creating...',
  'listNewTrip.updateTrip': 'Update Trip',
  'listNewTrip.submitRequest': 'Submit Request',
  'listNewTrip.departureDate': 'Departure date',
  'listNewTrip.pickWhenYouWillTravel': 'Pick when you will travel',
  'listNewTrip.quickSuggestionsKeepItSimple': 'Quick suggestions keep it simple, or use the calendar.',
  'listNewTrip.quickPicks': 'Quick picks',
  'listNewTrip.today': 'Today',
  'listNewTrip.tomorrow': 'Tomorrow',
  'listNewTrip.in3Days': 'In 3 days',
  'listNewTrip.nextWeek': 'Next week',
  'listNewTrip.calendar': 'Calendar',
  'listNewTrip.cancel': 'Cancel',
  'listNewTrip.useThisDate': 'Use this date',
  'listNewTrip.departureTime': 'Departure time',
  'listNewTrip.setClearTakeoffTime': 'Set a clear takeoff time',
  'listNewTrip.tapHourChooseMinutes': 'Tap the hour, choose minutes, then confirm below.',
  'listNewTrip.manualAdjust': 'Manual adjust',
  'listNewTrip.hour': 'Hour',
  'listNewTrip.minutes': 'Minutes',
  'listNewTrip.adjustsInMinuteSteps': 'Adjusts in {step}-minute steps',
  'listNewTrip.useThisTime': 'Use this time',
  'listNewTrip.pleaseSelectBothAddresses': 'Please select both origin and destination addresses',
  'listNewTrip.originDestinationCannotBeSame': 'Origin and destination cannot be the same',
  'listNewTrip.pleaseSelectDateAndTime': 'Please select both departure date and time',
  'listNewTrip.pleaseSelectDeliveryMethod': 'Please select a delivery method',
  'listNewTrip.pleaseEnterValidSpace': 'Please enter a valid space amount',
  'listNewTrip.pleaseEnterValidPricePerUnit': 'Please enter a valid price per unit',
  'listNewTrip.pleaseEnterValidFlatPrice': 'Please enter a valid flat price',
  'listNewTrip.notesCannotExceed': 'Notes cannot exceed 200 characters',
  'listNewTrip.pleaseAcceptBothAgreements': 'Please accept both agreements to continue',
  'listNewTrip.pleaseLogInToCreateTrip': 'Please log in to create a trip',
  'listNewTrip.tripUpdatedSuccessfully': 'Trip updated successfully!',
  'listNewTrip.tripListedSuccessfully': 'Trip listed successfully!',
  'listNewTrip.failedToUpdateTrip': 'Failed to update trip. Please try again.',
  'listNewTrip.failedToCreateTrip': 'Failed to create trip. Please try again.',
  
  // My Listings
  'myListings.myListings': 'My Listings',
  'myListings.manageTravelListings': 'Manage your travel listings and view incoming requests',
  'myListings.noListingsYet': 'No listings yet',
  'myListings.createNewTripListing': 'Create a new trip listing to start receiving delivery requests',
  'myListings.listNewTrip': 'List New Trip',
  'myListings.pleaseLogInToView': 'Please log in to view your listings',
  'myListings.goToLogin': 'Go to login',
  'myListings.completed': 'Completed',
  'myListings.route': 'Route',
  'myListings.departure': 'Departure',
  'myListings.pricing': 'Pricing',
  'myListings.available': 'Available',
  'myListings.pending': 'Pending',
  'myListings.accepted': 'Accepted',
  'myListings.total': 'Total',
  'myListings.done': 'Done',
  'myListings.view': 'View',
  'myListings.edit': 'Edit',
  'myListings.delete': 'Delete',
  'myListings.areYouSureDeleteTrip': 'Are you sure you want to delete this trip? This action cannot be undone and will also delete all associated requests.',
  'myListings.tripDeletedSuccessfully': 'Trip deleted successfully.',
  'myListings.failedToDeleteTrip': 'Failed to delete trip. Please try again.',
  'myListings.prev': 'Prev',
  'myListings.next': 'Next',

  // Edit Profile
  'editProfile.title': 'Edit profile',
  'editProfile.loginRequired': 'You need to be logged in to update your information.',
  'editProfile.loadError': 'Failed to load your profile details. Please try again.',
  'editProfile.heroTitle': 'Edit your profile',
  'editProfile.heroSubtitle': 'Update your personal information, username, and password. Changes apply instantly across both mobile and web experiences.',
  'editProfile.firstName': 'First name',
  'editProfile.firstNamePlaceholder': 'Enter your first name',
  'editProfile.lastName': 'Last name',
  'editProfile.lastNamePlaceholder': 'Enter your last name',
  'editProfile.username': 'Username',
  'editProfile.usernamePlaceholder': 'Choose a unique handle',
  'editProfile.usernameHelp': 'Usernames are unique and shown on your public profile.',
  'editProfile.email': 'Email',
  'editProfile.phone': 'Phone number',
  'editProfile.phonePlaceholder': '+1 555 555 5555',
  'editProfile.address': 'Address',
  'editProfile.addressPlaceholder': 'Enter your full address',
  'editProfile.addressHelp': 'Your address will be used for trip matching and delivery coordination.',
  'editProfile.currentPassword': 'Current password',
  'editProfile.currentPasswordPlaceholder': 'Required to change password',
  'editProfile.newPassword': 'New password',
  'editProfile.newPasswordPlaceholder': 'Leave blank to keep current password',
  'editProfile.confirmNewPassword': 'Confirm new password',
  'editProfile.confirmNewPasswordPlaceholder': 'Re-enter password',
  'editProfile.currentPasswordRequired': 'Please enter your current password to change it.',
  'editProfile.passwordsMismatch': 'Passwords do not match.',
  'editProfile.passwordTooShort': 'New password must be at least 6 characters.',
  'editProfile.updateSuccess': 'Profile updated successfully.',
  'editProfile.usernameTaken': 'That username is already in use. Please choose a different one.',
  'editProfile.reauthRequired': 'Please reauthenticate and try again to change your password.',
  'editProfile.updateErrorFallback': 'Failed to update profile. Please try again.',
  'editProfile.saving': 'Saving...',
  'editProfile.saveChanges': 'Save changes',

  // Profile
  'profile.sectionLabel': 'Profile',
  'profile.userFallback': 'User',
  'profile.title': 'Profile',
  'profile.loginRequired': 'Please sign in to view your profile.',
  'profile.heroBadge': 'My profile',
  'profile.heroTitle': 'Welcome back, {{name}}!',
  'profile.travelerFallback': 'traveler',
  'profile.heroSubtitle': 'Keep your account info up to date, review your stats, and manage verification all from one place.',
  'profile.memberSince': 'Member since {{date}}',
  'profile.verification': 'Verification',
  'profile.verified': 'Verified',
  'profile.pending': 'Pending',
  'profile.notVerified': 'Not verified',
  'profile.verifiedDescription': 'Your identity has been confirmed.',
  'profile.pendingDescription': 'Verification is under review.',
  'profile.notVerifiedDescription': 'Upload documents to become verified.',
  'profile.averageRating': 'Average rating',
  'profile.reviewsCount': '{{count}} review(s)',
  'profile.senderCompleted': 'Sender completed',
  'profile.travelerCompleted': 'Traveler completed',
  'profile.manage': 'Manage',
  'profile.editProfile': 'Edit profile',
  'profile.editProfileDescription': 'Update your name, username, password, and contact info.',
  'profile.publicView': 'Public view',
  'profile.viewProfile': 'View profile',
  'profile.viewProfileDescription': 'See what other users see, including reviews and stats.',
  'profile.openWallet': 'Open wallet',
  'profile.settingsAndLegal': 'Settings & legal',
  'profile.notifications': 'Notifications',
  'profile.identityVerification': 'Identity Verification',
  'profile.status': 'Status',
  'profile.pendingReview': 'Pending Review',
  'profile.rejected': 'Rejected',
  'profile.selectDocumentType': 'Select Document Type',
  'profile.passport': 'Passport',
  'profile.idCard': 'ID Card',
  'profile.driverLicence': 'Driver Licence',
  'profile.frontSide': 'Front Side',
  'profile.backSide': 'Back Side',
  'profile.clickToUploadFront': 'Click to upload front side',
  'profile.clickToUploadBack': 'Click to upload back side',
  'profile.submitting': 'Submitting...',
  'profile.uploading': 'Uploading...',
  'profile.submitForVerification': 'Submit for Verification',
  'profile.loadingLatest': 'Loading latest data...',
  'profile.supportTitle': 'Support',
  'profile.supportSubtitle': 'Tell us briefly what you need help with and our team will respond as soon as possible.',
  'profile.supportLoginRequired': 'You need to be logged in to contact support.',
  'profile.supportRequired': 'Please enter a subject and message.',
  'profile.supportSent': 'Your message has been sent. We will get back to you soon.',
  'profile.supportFailed': 'Failed to send support message. Please try again.',
  'profile.supportSubject': 'Subject',
  'profile.supportSubjectPlaceholder': 'Short title for your issue',
  'profile.supportMessage': 'Message',
  'profile.supportMessagePlaceholder': 'Describe your question or issue in detail',
  'profile.supportSending': 'Sending...',
  'profile.supportSend': 'Send message',
  'profile.supportHistoryTitle': 'Your previous requests',
  'profile.supportHistoryLoading': 'Loading...',
  'profile.supportHistoryEmpty': 'You have not created any support requests yet.',
  'profile.supportNewTicket': 'Create New Support Request',
  'profile.supportDetailNotFound': 'This support request could not be found.',
  'profile.supportPendingReply': 'Our team has received your message and will reply soon.',
  'profile.supportReplyLabel': 'Support reply',
  'profile.supportFollowupPlaceholder': 'Write a follow-up message about this issue',
  'profile.user': 'You',
  'profile.driverVerification': 'Driver Verification',
  'profile.driverVerificationNote': 'If you are a driver, please verify your documents',
  'profile.driverVerificationStatus': 'Driver Verification Status',
  'profile.driverLicenseFront': 'Driver License (Front)',
  'profile.driverLicenseBack': 'Driver License (Back)',
  'profile.vehicleInsurance': 'Vehicle Insurance Policy',
  'profile.submitDriverVerification': 'Submit Driver Verification',
  'profile.driverVerificationSubmitted': 'Driver verification submitted',
  'profile.pleaseSelectAllDriverFiles': 'Please select all required files',
  'profile.verificationSubmitted': 'Verification submitted',
  'profile.verificationFailed': 'Verification failed',
  'profile.verificationRejected': 'Verification Rejected',
  'profile.pleaseResubmit': 'Please resubmit your documents',
  'profile.selectDocumentTypeDesc': 'Please select a document type first',
  'profile.pleaseSelectFile': 'Please select both front and back files',
  'profile.uploadFile': 'Click to upload file',
  'profile.remove': 'Remove',
  'profile.selectSource': 'Select Source',
  'profile.selectSourceDesc': 'Choose where to pick the file from',
  'profile.fromGallery': 'From Gallery',
  'profile.fromFiles': 'From Files',
  'profile.failedPickFile': 'Failed to pick file',
  'profile.submitForApproval': 'Submit for Approval',

  // Profile Detail
  'profileDetail.back': '← Back',
  'profileDetail.memberSince': 'Member since {{date}}',
  'profileDetail.noEmail': 'No email provided',
  'profileDetail.rating': 'Rating',
  'profileDetail.completedDeliveries': 'Completed deliveries',
  'profileDetail.completedSenderTraveler': '{{sender}} as sender • {{traveler}} as traveler',
  'profileDetail.about': 'About',
  'profileDetail.completedSender': 'Completed (sender)',
  'profileDetail.completedTraveler': 'Completed (traveler)',
  'profileDetail.recentReviews': 'Recent reviews',
  'profileDetail.communitySays': 'What the community says',
  'profileDetail.backToProfile': 'Back to profile',
  'profileDetail.noReviews': 'No reviews yet.',
  'profileDetail.anonymous': 'Anonymous',
  'profileDetail.senderRole': 'Sender',
  'profileDetail.travelerRole': 'Traveler',

  // Settings - Privacy Policy
  'privacy.header': 'Privacy policy',
  'privacy.title': 'Your data, handled with care',
  'privacy.effective': 'Effective December 1, 2025 — Questions? Email',
  'privacy.overview.title': 'Overview',
  'privacy.overview.body1': 'At Flexy Group, we care about your privacy. This page explains what information we collect and how we use it.',
  'privacy.overview.body2': 'We encourage you to read these details carefully so you can use FlexySwap in the way that’s right for you.',
  'privacy.collect.title': 'Information We Collect',
  'privacy.collect.body1': 'Account details such as your name, email address, phone number, and profile photo.',
  'privacy.collect.body2': 'Verification info (government ID, selfie), travel itineraries, package descriptions, and messages exchanged in the app.',
  'privacy.collect.body3': 'Device and usage data, including IP address, browser type, and pages you visit, so we can keep FlexySwap secure.',
  'privacy.use.title': 'How We Use Information',
  'privacy.use.body1': 'To provide and improve the FlexySwap platform, including matching senders with travelers and processing payments.',
  'privacy.use.body2': 'To verify users, prevent fraud, and keep our community safe.',
  'privacy.use.body3': 'To communicate with you about bookings, updates, and support requests.',
  'privacy.sharing.title': 'Sharing & Disclosure',
  'privacy.sharing.body1': 'We do not sell your personal information.',
  'privacy.sharing.body2': 'We only share data with service providers (e.g., Stripe for payments, identity-verification partners) when it is necessary to deliver the service or comply with the law.',

  // Settings - Terms of Service
  'terms.header': 'Terms of service',
  'terms.title': 'Know your responsibilities',
  'terms.effective': 'Effective December 1, 2025 — Questions? Email',
  'terms.acceptance.title': 'Acceptance of Terms',
  'terms.acceptance.body1': 'By creating an account or using FlexySwap you agree to follow these Terms of Service and our Privacy Policy.',
  'terms.acceptance.body2': 'If you cannot agree, please do not use the platform.',
  'terms.service.title': 'FlexySwap Service',
  'terms.service.body1': 'FlexySwap connects senders and travelers. We are not a courier company and are not responsible for the items transported.',
  'terms.service.body2': 'Senders and Travelers enter into their own agreement; FlexySwap provides the technology and escrow wallet.',
  'terms.responsibilities.title': 'User Responsibilities',
  'terms.responsibilities.bullet1': 'You must be at least 18 years old and provide accurate information.',
  'terms.responsibilities.bullet2': 'Senders must accurately describe packages and avoid prohibited items.',
  'terms.responsibilities.bullet3': 'Travelers must comply with airline/customs rules and deliver packages safely.',
  'terms.financial.title': 'Financial Terms',
  'terms.financial.bullet1': 'FlexySwap collects payments via escrow and releases funds to the traveler after delivery.',
  'terms.financial.bullet2': 'Service fees are displayed before a booking is confirmed and are generally non‑refundable.',
  'terms.liability.title': 'Liability',
  'terms.liability.body1': 'To the maximum extent permitted by law, FlexySwap is not liable for indirect or consequential damages.',
  'terms.liability.body2': 'Our aggregate liability is limited to the service fees you paid in the last three months or $100 USD.',

  // Settings page
  'settings.heroBadge': 'Account settings',
  'settings.heroTitle': 'Control Your Experience',
  'settings.heroSubtitle': 'Update language preferences, review legal policies, and make sure FlexySwap behaves the way you expect.',
  'settings.preferences': 'Preferences',
  'settings.language': 'Language',
  'settings.languageDescription': 'Choose your default interface language. We\'ll remember this on your next visit.',
  'settings.languageNote': '(UI translations for the web experience are coming soon.)',
  'settings.theme': 'Theme',
  'settings.themeDescription': 'Match FlexySwap with your environment. Dark mode is easier on the eyes in low-light spaces.',
  'settings.lightMode': 'Light mode',
  'settings.darkMode': 'Dark mode',
  'settings.themeNote': 'We save this on your device so future visits keep the same look.',
  'settings.legal': 'Legal',
  'settings.policiesTitle': 'Policies & agreements',
  'settings.policiesDescription': 'Understand how we protect your data and the rules that keep FlexySwap safe.',
  'settings.privacyTitle': 'Privacy Policy',
  'settings.privacyPolicy': 'Privacy Policy',
  'settings.privacyDescription': 'Learn what personal data we collect and how it\'s handled.',
  'settings.termsTitle': 'Terms of Service',
  'settings.termsOfService': 'Terms of Service',
  'settings.termsDescription': 'Review your rights and responsibilities when using FlexySwap.',
  'settings.helpTitle': 'Need more help?',
  'settings.helpTextBefore': 'Email us anytime at',
  'settings.helpTextAfter': 'or reach out through the in-app support center.',
  'settings.openSupportChat': 'Open support chat',

  // Common actions
  'common.back': 'Back',
  'common.next': 'Next',
  'common.confirm': 'Confirm',

  // Flexy Ride - Create Passenger
  'flexyRidePassenger.validation.routeRequired': 'Please fill in all required fields (from, to, seats)',
  'flexyRidePassenger.validation.originDestinationSame': 'Origin and destination cannot be the same',
  'flexyRidePassenger.validation.seatsInvalid': 'Please enter a valid number of seats',
  'flexyRidePassenger.validation.dateTimeRequired': 'Please select both date and time',
  'flexyRidePassenger.validation.agreementsRequired': 'Please accept both agreements to continue',
  'flexyRidePassenger.validation.loginRequired': 'Please log in to create a listing',
  'flexyRidePassenger.successUpdate': 'Listing updated successfully!',
  'flexyRidePassenger.successCreate': 'Listing created successfully!',
  'flexyRidePassenger.errorGeneric': 'Failed to save listing. Please try again.',
  'flexyRidePassenger.routeTitle': 'Create a Ride request',
  'flexyRidePassenger.seats': 'Seats',
  'flexyRidePassenger.seatsPlaceholder': 'Number of seats',
  'flexyRidePassenger.preferencesTitle': 'Preferences',
  'flexyRidePassenger.smoking': 'Smoking',
  'flexyRidePassenger.pets': 'Pets',
  'flexyRidePassenger.luggage': 'Luggage',
  'flexyRidePassenger.comfort': 'Comfort',
  'flexyRidePassenger.no': 'No',
  'flexyRidePassenger.yes': 'Yes',
  'flexyRidePassenger.flexible': 'Flexible',
  'flexyRidePassenger.dateTimeTitle': 'Date & Time',
  'flexyRidePassenger.date': 'Date',
  'flexyRidePassenger.time': 'Time',
  'flexyRidePassenger.selectDate': 'Select date',
  'flexyRidePassenger.selectTime': 'Select time',
  'flexyRidePassenger.noteLabel': 'Note (optional)',
  'flexyRidePassenger.notePlaceholder': 'Add a note...',
  'flexyRidePassenger.summaryTitle': 'Summary',
  'flexyRidePassenger.summaryRoute': 'Route',
  'flexyRidePassenger.summaryDeparture': 'Departure',
  'flexyRidePassenger.summarySeats': 'Seats',
  'flexyRidePassenger.summarySeatsValue': '{{count}} seats requested',
  'flexyRidePassenger.summaryPreferences': 'Preferences',
  'flexyRidePassenger.summaryPreferencesValue': 'Smoking: {{smoking}} • Pets: {{pets}} • Luggage: {{luggage}} • Comfort: {{comfort}}',
  'flexyRidePassenger.summaryNote': 'Note',
  'flexyRidePassenger.dateNotSet': 'Date not set',
  'flexyRidePassenger.timeNotSet': 'Time not set',
  'flexyRidePassenger.agreeContact': 'Contact via app only',
  'flexyRidePassenger.agreePolicy': 'Accept prohibited items policy',
  'flexyRidePassenger.creating': 'Creating...',
  'flexyRidePassenger.updateListing': 'Update Listing',
  'flexyRidePassenger.create': 'Create',
  'flexyRidePassenger.selectDateTitle': 'Select Date',
  'flexyRidePassenger.selectTimeTitle': 'Select Time',

  // Flexy Ride - Create Seat
  'flexyRideSeat.validation.routeRequired': 'Please fill in all required fields (from, to, seats)',
  'flexyRideSeat.validation.originDestinationSame': 'Origin and destination cannot be the same',
  'flexyRideSeat.validation.seatsInvalid': 'Please enter a valid number of seats',
  'flexyRideSeat.validation.carInfoRequired': 'Please fill in all car information (brand, model, year)',
  'flexyRideSeat.validation.dateTimePriceRequired': 'Please select date, time, and enter price',
  'flexyRideSeat.validation.priceInvalid': 'Please enter a valid price',
  'flexyRideSeat.validation.agreementsRequired': 'Please accept both agreements to continue',
  'flexyRideSeat.validation.loginRequired': 'Please log in to create a listing',
  'flexyRideSeat.successUpdate': 'Listing updated successfully!',
  'flexyRideSeat.successCreate': 'Listing created successfully!',
  'flexyRideSeat.errorGeneric': 'Failed to save listing. Please try again.',
  'flexyRideSeat.routeTitle': 'List a new route',
  'flexyRideSeat.seats': 'Seats',
  'flexyRideSeat.seatsPlaceholder': 'Number of seats',
  'flexyRideSeat.preferencesTitle': 'Preferences & Car Information',
  'flexyRideSeat.smoking': 'Smoking',
  'flexyRideSeat.pets': 'Pets',
  'flexyRideSeat.luggage': 'Luggage',
  'flexyRideSeat.comfort': 'Comfort',
  'flexyRideSeat.no': 'No',
  'flexyRideSeat.yes': 'Yes',
  'flexyRideSeat.flexible': 'Flexible',
  'flexyRideSeat.carBrand': 'Car Brand *',
  'flexyRideSeat.carBrandPlaceholder': 'e.g., Toyota',
  'flexyRideSeat.carModel': 'Car Model *',
  'flexyRideSeat.carModelPlaceholder': 'e.g., Camry',
  'flexyRideSeat.carYear': 'Car Year *',
  'flexyRideSeat.carYearPlaceholder': 'e.g., 2020',
  'flexyRideSeat.dateTimeTitle': 'Date, Time & Price',
  'flexyRideSeat.date': 'Date *',
  'flexyRideSeat.time': 'Time *',
  'flexyRideSeat.selectDate': 'Select date',
  'flexyRideSeat.selectTime': 'Select time',
  'flexyRideSeat.priceWithSeats': 'Price ({{count}} seats total) *',
  'flexyRideSeat.pricePlaceholder': 'Enter price',
  'flexyRideSeat.noteLabel': 'Note (optional)',
  'flexyRideSeat.notePlaceholder': 'Add a note...',
  'flexyRideSeat.summaryTitle': 'Summary',
  'flexyRideSeat.summaryRoute': 'Route',
  'flexyRideSeat.summaryDeparture': 'Departure',
  'flexyRideSeat.summarySeatsPrice': 'Seats & Price',
  'flexyRideSeat.summarySeatsPriceValue': '{{seats}} seats • CAD ${{price}}',
  'flexyRideSeat.summaryPreferences': 'Preferences',
  'flexyRideSeat.summaryPreferencesValue': 'Smoking: {{smoking}} • Pets: {{pets}} • Luggage: {{luggage}} • Comfort: {{comfort}}',
  'flexyRideSeat.summaryVehicle': 'Vehicle',
  'flexyRideSeat.summaryNote': 'Note',
  'flexyRideSeat.dateNotSet': 'Date not set',
  'flexyRideSeat.timeNotSet': 'Time not set',
  'flexyRideSeat.agreeContact': 'Contact via app only',
  'flexyRideSeat.agreePolicy': 'Accept prohibited items policy',
  'flexyRideSeat.creating': 'Creating...',
  'flexyRideSeat.updateListing': 'Update Listing',
  'flexyRideSeat.create': 'Create',
  'flexyRideSeat.selectDateTitle': 'Select Date',
  'flexyRideSeat.selectTimeTitle': 'Select Time',

  // Flexy Ride detail (passenger & seat)
  'flexyRideDetail.listingIdNotFound': 'Listing ID not found',
  'flexyRideDetail.listingNotFound': 'Listing not found',
  'flexyRideDetail.failedToLoadListing': 'Failed to load listing',
  'flexyRideDetail.requestSent': 'Request sent successfully!',
  'flexyRideDetail.failedToSendRequest': 'Failed to send request. Please try again.',
  'flexyRideDetail.applyOwnListing': 'You cannot apply to your own listing.',
  'flexyRideDetail.alreadyApplied': 'You have already sent a request to this listing.',
  'flexyRideDetail.backToListings': 'Back to listings',
  'flexyRideDetail.verifiedPassenger': 'Verified passenger',
  'flexyRideDetail.unverifiedPassenger': 'Unverified passenger',
  'flexyRideDetail.verifiedDriver': 'Verified driver',
  'flexyRideDetail.unverifiedDriver': 'Unverified driver',
  'flexyRideDetail.passengerBadge': 'Flexy Ride • Passenger listing',
  'flexyRideDetail.seatBadge': 'Flexy Ride • Seat listing',
  'flexyRideDetail.route': 'Route',
  'flexyRideDetail.preferredCar': 'Preferred Car',
  'flexyRideDetail.passenger.applyLoginDriver': 'Please sign in to apply as a driver.',
  'flexyRideDetail.seat.applyLoginSeat': 'Please sign in to apply for a seat.',
  'flexyRideDetail.passenger.messageLogin': 'Please sign in to message the passenger.',
  'flexyRideDetail.seat.messageLogin': 'Please sign in to message the driver.',
  'flexyRideDetail.signInToApplyDriver': 'Sign in to apply',
  'flexyRideDetail.signInToApplySeat': 'Sign in to apply',
  'flexyRideDetail.applied': 'Applied',
  'flexyRideDetail.applyAsDriver': 'Apply as driver',
  'flexyRideDetail.applyForSeat': 'Apply for seat',

  // Flexy Ride - My Applications
  'flexyRideApplications.title': 'My Applications',
  'flexyRideApplications.subtitle':
    'View and manage your passenger ride applications',
  'flexyRideApplications.statusPending': 'Pending',
  'flexyRideApplications.statusAccepted': 'Accepted',
  'flexyRideApplications.statusRejected': 'Rejected',
  'flexyRideApplications.statusCompleted': 'Completed',
  'flexyRideApplications.statusCancelled': 'Cancelled',
  'flexyRideApplications.statusUnknown': 'Unknown',
  'flexyRideApplications.loginToRate': 'Please log in to rate other users.',
  'flexyRideApplications.driverInfoMissing': 'Driver information is missing.',
  'flexyRideApplications.alreadyReviewed':
    'You have already reviewed this user.',
  'flexyRideApplications.driverFallback': 'Driver',
  'flexyRideApplications.reviewModalError':
    'Failed to open review modal. Please try again.',
  'flexyRideApplications.passengerLabel': 'Passenger',
  'flexyRideApplications.route': 'Route',
  'home.fromFallback': 'Origin',
  'home.toFallback': 'Destination',
  'flexyRideApplications.seatsRequested': 'Seats requested: {{count}}',
  'flexyRideApplications.priceLabel': 'Price:',
  'flexyRideApplications.priceNA': 'N/A',
  'flexyRideApplications.yourOffer': 'Your Offer',
  'flexyRideApplications.priceLabelInline': 'Price: {{price}} {{currency}}',
  'flexyRideApplications.carLabel': 'Car: {{brand}}',
  'flexyRideApplications.noteLabel': 'Note: {{note}}',
  'flexyRideApplications.offerSent':
    'Your offer has been sent to the listing owner.',
  'flexyRideApplications.rideInProgress':
    'Ride in progress. Awaiting payment from {{name}}.',
  'flexyRideApplications.paymentCompleted':
    'Payment completed. We hope your journey was smooth!',
  'flexyRideApplications.reviewed': 'Reviewed',
  'flexyRideApplications.rate': 'Rate',
  'flexyRideApplications.loginToViewApplications':
    'Please log in to view your applications',
  'flexyRideApplications.emptyTitle': 'No applications yet',
  'flexyRideApplications.emptyDescription':
    "You haven't applied to any passenger ride listings yet",
  'flexyRideApplications.browseRides': 'Browse Rides',

  // Flexy Ride - My Passenger Listings
  'flexyRideMyPassengerListings.title': 'My Passenger Listings',
  'flexyRideMyPassengerListings.subtitle':
    'Manage your passenger ride listings and view incoming requests',
  'flexyRideMyPassengerListings.deleteConfirm':
    'Are you sure you want to delete this listing? This action cannot be undone.',
  'flexyRideMyPassengerListings.deleteSuccess':
    'Listing deleted successfully.',
  'flexyRideMyPassengerListings.deleteError':
    'Failed to delete listing. Please try again.',
  'flexyRideMyPassengerListings.completedBadge': 'Completed',
  'flexyRideMyPassengerListings.route': 'Route',
  'flexyRideMyPassengerListings.seatsRequested':
    '{{count}} seats requested',
  'flexyRideMyPassengerListings.note': 'Note',
  'flexyRideMyPassengerListings.requests': 'Requests',
  'flexyRideMyPassengerListings.viewRequests':
    'View ({{count}})',
  'flexyRideMyPassengerListings.loginToViewListings':
    'Please log in to view your listings',
  'flexyRideMyPassengerListings.emptyTitle': 'No listings yet',
  'flexyRideMyPassengerListings.emptyDescription':
    'Create a new passenger listing to start receiving driver requests',
  'flexyRideMyPassengerListings.createListing': 'Create Listing',

  // Flexy Ride - My Seat Requests
  'flexyRideMyRequests.title': 'My Seat Requests',
  'flexyRideMyRequests.subtitle': 'View and manage your seat requests to drivers',
  'flexyRideMyRequests.driverLabel': 'Driver',
  'flexyRideMyRequests.route': 'Route',
  'flexyRideMyRequests.priceSeatsSuffix': '({{count}} seats)',
  'flexyRideMyRequests.vehicleLabel': 'Vehicle:',
  'flexyRideMyRequests.acceptedMessage':
    'We wish you a pleasant journey. You can complete your payment from the Confirm Payment button.',
  'flexyRideMyRequests.completedMessage':
    'Payment has been completed. We hope your journey was smooth. Looking forward to seeing you on your next trips.',
  'flexyRideMyRequests.confirmPaymentButton': 'Confirm Payment',
  'flexyRideMyRequests.loginToViewRequests':
    'Please log in to view your requests',
  'flexyRideMyRequests.emptyTitle': 'No requests yet',
  'flexyRideMyRequests.emptyDescription':
    "You haven't sent any seat requests to drivers yet",
  'flexyRideMyRequests.browseSeats': 'Browse Seats',
  'flexyRideMyRequests.paymentConfirmError':
    'Failed to confirm payment. Please try again.',
  'flexyRideMyRequests.modalTitle': 'Confirm Payment',
  'flexyRideMyRequests.modalSubtotal': 'Subtotal',
  'flexyRideMyRequests.modalFees': 'Fees (15%)',
  'flexyRideMyRequests.modalTipLabel': 'Tip (Optional)',
  'flexyRideMyRequests.modalTip': 'Tip',
  'flexyRideMyRequests.modalTipPlaceholder': '0.00',
  'flexyRideMyRequests.modalTotal': 'Total',
  'flexyRideMyRequests.modalProcessing': 'Processing...',

  // Flexy Ride - My Seat Listings
  'flexyRideMySeatListings.title': 'My Seat Listings',
  'flexyRideMySeatListings.subtitle':
    'Manage your seat listings and view incoming requests',
  'flexyRideMySeatListings.deleteConfirm':
    'Are you sure you want to delete this listing? This action cannot be undone.',
  'flexyRideMySeatListings.deleteSuccess': 'Listing deleted successfully.',
  'flexyRideMySeatListings.deleteError':
    'Failed to delete listing. Please try again.',
  'flexyRideMySeatListings.completedBadge': 'Completed',
  'flexyRideMySeatListings.route': 'Route',
  'flexyRideMySeatListings.pricing': 'Pricing',
  'flexyRideMySeatListings.pricingValue':
    '{{currency}} ${{price}} ({{seats}} seats)',
  'flexyRideMySeatListings.note': 'Note',
  'flexyRideMySeatListings.requests': 'Requests',
  'flexyRideMySeatListings.viewRequests': 'View ({{count}})',
  'flexyRideMySeatListings.loginToViewListings':
    'Please log in to view your listings',
  'flexyRideMySeatListings.emptyTitle': 'No listings yet',
  'flexyRideMySeatListings.emptyDescription':
    'Create a new seat listing to start receiving passenger requests',
  'flexyRideMySeatListings.createListing': 'Create Listing',

  // Flexy Ride - Passenger Listing Requests (driver offers to passenger listing)
  'flexyRidePassengerRequests.title': 'Passenger Listing Requests',
  'flexyRidePassengerRequests.subtitle':
    'Manage incoming driver offers for your passenger listings.',
  'flexyRidePassengerRequests.paymentPending': 'Payment Pending',
  'flexyRidePassengerRequests.loginToAccept':
    'Please log in to accept applications.',
  'flexyRidePassengerRequests.loginToReject':
    'Please log in to reject applications.',
  'flexyRidePassengerRequests.loginToView':
    'Please log in to view requests.',
  'flexyRidePassengerRequests.applicationNotFound': 'Application not found.',
  'flexyRidePassengerRequests.onlyOwnListings':
    'You can only manage applications for your own listings.',
  'flexyRidePassengerRequests.insufficientBalance':
    'Insufficient balance. You need {{currency}} {{total}} but have {{currency}} {{balance}}.',
  'flexyRidePassengerRequests.acceptSuccess':
    'Application accepted successfully!',
  'flexyRidePassengerRequests.acceptError':
    'Failed to accept application. Please try again.',
  'flexyRidePassengerRequests.rejectSuccess': 'Application rejected.',
  'flexyRidePassengerRequests.rejectError':
    'Failed to reject application. Please try again.',
  'flexyRidePassengerRequests.requestNotFound': 'Request not found',
  'flexyRidePassengerRequests.paymentAlreadyConfirmed':
    'Payment already confirmed.',
  'flexyRidePassengerRequests.payerReceiverMissing':
    'Payer or receiver ID missing',
  'flexyRidePassengerRequests.rideRequestTitle': 'Ride request',
  'flexyRidePassengerRequests.userNotAuthenticated':
    'User not authenticated',
  'flexyRidePassengerRequests.paymentConfirmSuccess':
    'Payment confirmed. Ride completed successfully!',
  'flexyRidePassengerRequests.paymentConfirmError':
    'Failed to confirm payment. Please try again.',
  'flexyRidePassengerRequests.route': 'Route',
  'flexyRidePassengerRequests.seatsRequested': 'Seats Requested',
  'flexyRidePassengerRequests.empty': 'No applications found.',
  'flexyRidePassengerRequests.requestingDriver': 'Requesting Driver',
  'flexyRidePassengerRequests.offer': 'Offer',
  'flexyRidePassengerRequests.offerPriceValue':
    '{{price}} {{currency}}',
  'flexyRidePassengerRequests.offerCarValue': 'Car: {{brand}}',
  'flexyRidePassengerRequests.paymentCompleted': 'Payment completed',
  'flexyRidePassengerRequests.rideRequestFormatted': 'Ride: {{from}} → {{to}}',

  // Flexy Ride - Seat Listing Requests (passenger applications to seat listing)
  'flexyRideSeatRequests.title': 'Seat Listing Requests',
  'flexyRideSeatRequests.subtitle':
    'Manage incoming passenger applications for your seat listings.',
  'flexyRideSeatRequests.loginToAccept':
    'Please log in to accept applications.',
  'flexyRideSeatRequests.loginToReject':
    'Please log in to reject applications.',
  'flexyRideSeatRequests.loginToView':
    'Please log in to view requests.',
  'flexyRideSeatRequests.applicationNotFound': 'Application not found.',
  'flexyRideSeatRequests.onlyOwnListings':
    'You can only manage applications for your own listings.',
  'flexyRideSeatRequests.acceptSuccess':
    'Application accepted successfully!',
  'flexyRideSeatRequests.acceptError':
    'Failed to accept application. Please try again.',
  'flexyRideSeatRequests.rejectSuccess': 'Application rejected.',
  'flexyRideSeatRequests.rejectError':
    'Failed to reject application. Please try again.',
  'flexyRideSeatRequests.route': 'Route',
  'flexyRideSeatRequests.availableSeats': 'Available Seats',
  'flexyRideSeatRequests.availableSeatsValue': '{{seats}}',
  'flexyRideSeatRequests.availableSeatsWithPrice': '{{seats}} • {{currency}} {{price}}',
  'flexyRideSeatRequests.empty':
    'No applications found for your seat listings.',
  'flexyRideSeatRequests.requestingPassenger': 'Requesting Passenger',
  'flexyRideSeatRequests.price': 'Price',
  'flexyRideSeatRequests.paymentCompleted': 'Payment completed',
  'flexyRideSeatRequests.paymentCompletedMessage':
    'Payment was successful. Looking forward to seeing you on your next trips.',
  'flexyRideSeatRequests.rideInProgress':
    'Ride in progress. Awaiting payment from {{name}}.',

  // Notifications page
  'notifications.title': 'Notifications',
  'notifications.badge': 'Stay Updated',
  'notifications.heroDescription':
    'Track trip activity, request updates, wallet events, and system alerts in one place.',
  'notifications.total': '{{count}} total',
  'notifications.unread': '{{count}} unread',
  'notifications.sectionTitle': 'Latest Activity',
  'notifications.sectionDescription':
    'View everything happening with your trips, requests, and account.',
  'notifications.markAll': 'Mark all as read',
  'notifications.emptyTitle': "You're all caught up!",
  'notifications.emptyDescription':
    "We'll keep your updates here. Check back after new trip or request activity.",
  'notifications.exploreTrips': 'Explore trips',
  'notifications.defaultTitle': 'Notification',
  'notifications.defaultBody': 'You have an update',
  'notifications.new': 'New',
  'notifications.asSender': 'As Sender',
  'notifications.asTraveler': 'As Traveler',
  'notifications.requestId': 'Request ID:',
  'notifications.loginDescription':
    'Please sign in to view your activity, updates, and reminders.',

  // Marketing footer
  'footer.trustedSwaps': 'Trusted swaps',
  'footer.description':
    'FlexySwap is the peer-to-peer logistics network that helps travelers monetize unused luggage space while senders move packages safely across the globe.',
  'footer.downloadAppsTitle': 'Download our mobile apps',
  'footer.downloadAppsDescription':
    'Keep every swap synced with real-time notifications and secure payouts on the go.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.copyright':
    '© {{year}} FlexySwap. All rights reserved.',

  // Route planner & trips map
  'routePlanner.fromPlaceholder': 'Airport, bus station, hotel...',
  'routePlanner.toPlaceholder': 'Drop-off point',
  'routePlanner.loadingMaps': 'Loading Google Maps...',

  'tripsMap.mapPreview': 'Map preview',
  'tripsMap.defaultTitle': 'Available trips on the map',
  'tripsMap.showingLocations': 'Showing {{count}} locations',
  'tripsMap.selectedTrip': 'Selected trip',
  'tripsMap.viewDetails': 'View details',
  'tripsMap.route': 'Route',
  'tripsMap.capacity': 'Capacity',

  // Request Modal
  'requestModal.title': 'Request Delivery',
  'requestModal.travelerFallback': 'Traveler',
  'requestModal.itemDetails': 'Item Details',
  'requestModal.itemName': 'Item Name',
  'requestModal.itemNamePlaceholder': 'e.g., Documents, Electronics, Clothes',
  'requestModal.notesLabel': 'Notes (Optional)',
  'requestModal.notesPlaceholder': 'Any special instructions or details',
  'requestModal.pricing': 'Pricing',
  'requestModal.subtotal': 'Subtotal:',
  'requestModal.serviceFee': 'Service Fee (15%):',
  'requestModal.total': 'Total:',
  'requestModal.loadingBalance': 'Loading balance...',
  'requestModal.balance': 'Your balance: {{currency}} {{amount}}',
  'requestModal.sending': 'Sending...',
  'requestModal.sendRequest': 'Send Request',
  'requestModal.validation.itemNameRequired': 'Please enter an item name',
  'requestModal.validation.loginRequired': 'Please log in to send a request',
  'requestModal.validation.insufficientBalance': 'You have {{currency}} {{current}} but need {{currency}} {{total}}.\nPlease add {{currency}} {{shortfall}} to your wallet.',
  'requestModal.error.tripIdMissing': 'Trip ID is missing',
  'requestModal.error.tripOwnerMissing': 'Trip owner ID is missing',
  'requestModal.error.generic': 'Failed to send request. Please try again.',
  'requestModal.success': 'Request sent successfully!',

  // Send Offer Modal
  'sendOfferModal.title': 'Request to Carry',
  'sendOfferModal.senderFallback': 'Sender',
  'sendOfferModal.deliveryMethodLabel': 'Delivery Method',
  'sendOfferModal.selectDeliveryMethodPlaceholder': 'Select delivery method',
  'sendOfferModal.askingPrice': 'My Asking Price',
  'sendOfferModal.pricePlaceholder': 'Enter amount',
  'sendOfferModal.notesLabel': 'Notes (Optional)',
  'sendOfferModal.notesPlaceholder': 'Any special instructions for carrying your items',
  'sendOfferModal.itemFallback': 'Item',
  'sendOfferModal.selectDeliveryMethodTitle': 'Select Delivery Method',
  'sendOfferModal.send': 'Send',
  'sendOfferModal.sending': 'Sending...',
  'sendOfferModal.validation.deliveryMethodRequired': 'Please select delivery method',
  'sendOfferModal.validation.priceRequired': 'Please enter a valid price',
  'sendOfferModal.validation.currencyRequired': 'Please select currency',
  'sendOfferModal.validation.loginRequired': 'Please log in to send an offer',
  'sendOfferModal.error.tripIdMissing': 'Trip ID is missing',
  'sendOfferModal.error.tripOwnerMissing': 'Trip owner ID is missing',
  'sendOfferModal.error.generic': 'Failed to send offer. Please try again.',
  'sendOfferModal.success': 'Offer sent successfully!',

  // Review Modal
  'reviewModal.title': 'Rate Your Experience',
  'reviewModal.description': 'How was your experience with {{name}}?',
  'reviewModal.descriptionFallback': 'Share your feedback with this user.',
  'reviewModal.placeholder': 'Write a review (optional)...',
  'reviewModal.selectRatingError': 'Please select a rating before submitting.',
  'reviewModal.submitError': 'Failed to submit review. Please try again.',
  'reviewModal.submitting': 'Submitting...',
  'reviewModal.submit': 'Submit',

  // Wallet
  'wallet.title': 'Wallet',
  'wallet.badge': 'Wallet & Balance',
  'wallet.heroTitle': 'Your FlexySwap Wallet',
  'wallet.heroDescription':
    'Keep an eye on deposits, withdrawals, and trip earnings from one place. Manage payout accounts and review every transaction with confidence.',
  'wallet.loginDescription':
    'Please sign in to view your wallet balance and transactions.',
  'wallet.loading': 'Loading wallet data...',
  'wallet.availableBalance': 'Available Balance',
  'wallet.availableBalanceLabel': 'Available Balance · {{amount}}',
  'wallet.totalTransactions': '{{count}} total transactions',
  'wallet.balanceDescription':
    'Updated automatically from your trip earnings, deposits, and withdrawals.',
  'wallet.addMoney': 'Add money',
  'wallet.accountStatus': 'Account Status',
  'wallet.depositAccount': 'Deposit Account',
  'wallet.depositAccountStatus': 'Stripe payments · Ready',
  'wallet.withdrawalAccount': 'Withdrawal Account',
  'wallet.withdrawalAccountConnected': 'Connected · …{{accountId}}',
  'wallet.withdrawalAccountNotConnected': 'Not connected',
  'wallet.manage': 'Manage',
  'wallet.configure': 'Configure',
  'wallet.totalDeposits': 'Total Deposits',
  'wallet.depositsCount_one': '{{count}} deposit',
  'wallet.depositsCount_other': '{{count}} deposits',
  'wallet.totalWithdrawals': 'Total Withdrawals',
  'wallet.withdrawalsCount_one': '{{count}} withdrawal',
  'wallet.withdrawalsCount_other': '{{count}} withdrawals',
  'wallet.transactions': 'Transactions',
  'wallet.lifetimeActivity': 'Lifetime activity',
  'wallet.recentTransactions': 'Recent Transactions',
  'wallet.activity': 'Activity',
  'wallet.viewAll': 'View all',
  'wallet.noTransactions':
    'No transactions yet. Once you start sending or delivering packages, your earnings and payments will appear here.',
  'wallet.walletActivity': 'Wallet Activity',
  'wallet.statusCompleted': 'completed',

  // All Transactions
  'wallet.allTransactions.backToWallet': 'Back to wallet',
  'wallet.allTransactions.title': 'All Transactions',
  'wallet.allTransactions.subtitle':
    'Detailed view of deposits, withdrawals, and trip payments.',
  'wallet.allTransactions.filter.all': 'All',
  'wallet.allTransactions.filter.deposit': 'Deposit',
  'wallet.allTransactions.filter.withdrawal': 'Withdrawal',
  'wallet.allTransactions.filter.earning': 'Earning',
  'wallet.allTransactions.filter.payment': 'Payment',
  'wallet.allTransactions.noTransactions':
    'No transactions found for this filter.',
  'wallet.allTransactions.table.description': 'Description',
  'wallet.allTransactions.table.type': 'Type',
  'wallet.allTransactions.table.amount': 'Amount',
  'wallet.allTransactions.table.status': 'Status',
  'wallet.allTransactions.table.date': 'Date',
  'wallet.allTransactions.transactionType.deposit': 'Deposit',
  'wallet.allTransactions.transactionType.withdrawal': 'Withdrawal',
  'wallet.allTransactions.transactionType.earning': 'Earning',
  'wallet.allTransactions.transactionType.payment': 'Payment',
  'wallet.allTransactions.details': 'Details',

  // Transaction Detail
  'wallet.transactionDetail.backToTransactions': 'Back to transactions',
  'wallet.transactionDetail.loading': 'Loading transaction details...',
  'wallet.transactionDetail.notFound': 'Transaction not found.',
  'wallet.transactionDetail.title': 'Transaction Details',
  'wallet.transactionDetail.type.deposit': 'Deposit',
  'wallet.transactionDetail.type.withdrawal': 'Withdrawal',
  'wallet.transactionDetail.type.earning': 'Trip earning',
  'wallet.transactionDetail.type.walletActivity': 'Wallet activity',
  'wallet.transactionDetail.detail.description': 'Description',
  'wallet.transactionDetail.detail.walletActivity': 'Wallet activity',
  'wallet.transactionDetail.detail.status': 'Status',
  'wallet.transactionDetail.detail.date': 'Date',
  'wallet.transactionDetail.detail.from': 'From',
  'wallet.transactionDetail.detail.to': 'To',
  'wallet.transactionDetail.detail.requestId': 'Request ID',
  'wallet.transactionDetail.detail.paymentMethod': 'Payment Method',
  'wallet.transactionDetail.detail.withdrawalMethod': 'Withdrawal Method',
  'wallet.transactionDetail.detail.tip': 'Tip',

  // Withdrawal Account
  'wallet.withdrawalAccount.withdrawalMethod': 'Withdrawal Method',
  'wallet.withdrawalAccount.title': 'Stripe Connect Payouts',
  'wallet.withdrawalAccount.description':
    'Connect your Stripe Express account to receive payouts. Once your account is verified, withdrawals from the FlexySwap wallet can be sent directly to your bank. The onboarding flow will ask for your legal name, bank account, and verification documents as required by Stripe.',
  'wallet.withdrawalAccount.currentStatus': 'Current status',
  'wallet.withdrawalAccount.onboardingOpened':
    'Stripe Connect onboarding opened in a new tab.',
  'wallet.withdrawalAccount.unableToStartOnboarding':
    'Unable to start Stripe onboarding.',
  'wallet.withdrawalAccount.accountNotFound':
    'Stripe Connect account not found. Complete onboarding first.',
  'wallet.withdrawalAccount.unableToCheckStatus':
    'Unable to check account status.',
  'wallet.withdrawalAccount.startOnboarding': 'Start onboarding',
  'wallet.withdrawalAccount.securityNote':
    'Stripe stores your banking information securely. FlexySwap only tracks the connection state and never sees your account numbers.',

  // Deposit Account
  'wallet.depositAccount.depositMethod': 'Deposit Method',
  'wallet.depositAccount.title': 'Card Payments via Stripe',
  'wallet.depositAccount.description':
    'FlexySwap uses Stripe for secure card payments. Your deposit account is automatically prepared when you verify your profile. No manual setup is required—just select an amount to add funds on the Add Money page.',
  'wallet.depositAccount.cardsSupported': 'Cards supported',
  'wallet.depositAccount.cardsList': 'Visa, Mastercard, Amex, Maestro',
  'wallet.depositAccount.securityNote':
    'Card details are tokenized by Stripe. FlexySwap never stores your payment information. Every charge is protected with Stripe Radar for fraud prevention.',
  'wallet.depositAccount.infoNote':
    'Need to update your card? Start a new deposit from the Add Money page to add a different card. Receipts are emailed automatically by Stripe.',
  'wallet.depositAccount.makeDeposit': 'Make a deposit',

  // Withdraw Money
  'wallet.withdrawMoney.title': 'Withdraw Money',
  'wallet.withdrawMoney.signInToAccess': 'Please sign in to access your wallet.',
  'wallet.withdrawMoney.insufficientBalance':
    'Insufficient balance. Available: {{available}}',
  'wallet.withdrawMoney.accountReady':
    'Your account is ready for withdrawals!',
  'wallet.withdrawMoney.noAccountFound':
    'No Stripe Connect account found. Please set up your account first.',
  'wallet.withdrawMoney.failedToCheckStatus':
    'Failed to check account status: {{error}}',
  'wallet.withdrawMoney.payoutsNotAvailable':
    'Stripe Connect payouts are not available in {{country}}. Please update your profile with a supported country.',
  'wallet.withdrawMoney.unableToGetOnboardingLink':
    'Unable to get Stripe onboarding link.',
  'wallet.withdrawMoney.failedToSetupAccount':
    'Failed to setup account: {{error}}',
  'wallet.withdrawMoney.enterValidAmount': 'Please enter a valid amount.',
  'wallet.withdrawMoney.connectAccountFirst':
    'Connect a payout account before withdrawing.',
  'wallet.withdrawMoney.withdrawalsNotAvailable':
    'Withdrawals are not available in {{country}}. Please update your profile with a supported country.',
  'wallet.withdrawMoney.accountNeedsSetup':
    'Your Stripe Connect account needs to be set up or completed. Please complete the account setup first.',
  'wallet.withdrawMoney.accountSetupInProgress':
    'Account setup is still in progress. Please wait a moment and try again.',
  'wallet.withdrawMoney.withdrawalQueued':
    'Withdrawal of {{amount}} queued. Payouts usually arrive within 2-3 business days.',
  'wallet.withdrawMoney.failedToSubmit': 'Failed to submit withdrawal.',
  'wallet.withdrawMoney.connectPayoutAccount': 'Connect payout account',
  'wallet.withdrawMoney.generatingOnboardingLink':
    'Generating Stripe onboarding link...',
  'wallet.withdrawMoney.onboardingOpened':
    "Stripe's onboarding opened in a new tab. If it was blocked or you closed it, use the button below to reopen.",
  'wallet.withdrawMoney.openOnboarding': 'Open Stripe onboarding',
  'wallet.withdrawMoney.clickToLaunch':
    'Click "Connect / update" to launch Stripe onboarding.',

  // Auth / Login
  'auth.loginSuccess': 'Welcome back! Redirecting…',
  'auth.signupSuccess': 'Account created! You are now signed in.',
  'auth.usernameRequired': 'Username is required.',
  'auth.resetEnterEmail': 'Enter your email to reset the password.',
  'auth.resetEmailSent': 'Password reset email sent.',

  'auth.badgeSignin': 'Sign in',
  'auth.badgeSignup': 'Create an account',
  'auth.heroSigninTitle': 'Drive whenever you want, earn what you need.',
  'auth.heroSignupTitle': 'Join FlexySwap and start earning today.',
  'auth.heroSigninSubtitle':
    'Pick up where you left off across sender & traveler consoles.',
  'auth.heroSignupSubtitle':
    'Publish trips, manage requests, and sync every hand-off instantly.',

  'auth.identifierLabel': 'Email or username',
  'auth.identifierPlaceholder': 'email@example.com or username',
  'auth.emailLabel': 'Email',
  'auth.usernameLabel': 'Username',
  'auth.passwordLabel': 'Password',

  'auth.forgotPassword': 'Forgot password?',
  'auth.signingIn': 'Signing in...',
  'auth.creatingAccount': 'Creating account...',
  'auth.signinCta': 'Sign in',
  'auth.signupCta': 'Sign up',

  'auth.noAccount': "Don't have an account?",
  'auth.haveAccount': 'Already have an account?',
  'auth.createOne': 'Create one',
  'auth.signinLink': 'Sign in',

  'auth.downloadApp': 'Download mobile app',
  'auth.sideHeroTitle': 'Meet at the gate, swap in seconds.',
  'auth.sideHeroDescription':
    'Verified travelers collect your parcel, confirm IDs, and sync the status back to your FlexySwap dashboard instantly.',
  'auth.sideHeroPillTracking': 'Real-time tracking',
  'auth.sideHeroPillPayouts': 'Secure payouts',
  'auth.sideHeroPillIds': 'Verified IDs',

  // Login terms and privacy
  'login.acceptTerms': 'I accept the',
  'login.termsOfService': 'Terms of Service',
  'login.and': 'and',
  'login.privacyPolicy': 'Privacy Policy',
  'login.mustAcceptTerms': 'You must accept the Terms of Service and Privacy Policy to create an account',
};

